export default {
    "generalErrorMessage": {
        "fieldIsRequired": "Το πεδίο είναι υποχρεωτικό",
        "field_required": "Αυτό το πεδίο είναι υποχρεωτικό",
        "something_went_wrong": "Κάτι πήγε στραβά"
    },
    "authErrorMessage": {
        "emailError": "Το πεδίο email πρέπει να είναι έγκυρο email",
        "passwordValid": "Το πεδίο του κωδικού πρόσβασης πρέπει να έχει τουλάχιστον 8 χαρακτήρες",
        "validPassRegex": "Οι κωδικοί πρόσβασης πρέπει να έχουν τουλάχιστον 8 χαρακτήρες και να περιέχουν τουλάχιστον 1 αλφαβητικό χαρακτήρα, 1 κεφαλαίο, 1 αριθμητικό και 1 ειδικό χαρακτήρα",
        "confirmPasswordValid": "Η επιβεβαίωση του κωδικού πρόσβασης δεν ταιριάζει",
        "validCharactersfirst": "Το πεδίο του ονόματος μπορεί να περιέχει μόνο αλφαβητικούς χαρακτήρες καθώς και κενά",
        "validCharacterslast": "Το πεδίο του επωνύμου μπορεί να περιέχει μόνο αλφαβητικούς χαρακτήρες καθώς και κενά",
        "minMust": "πρέπει να είναι τουλάχιστον 3 χαρακτήρες",
        "must_be_a_valid_email": "Πρέπει να είναι έγκυρο email",
        "currentPassword": "Οι τρέχοντες κωδικοί πρόσβασης πρέπει να έχουν μήκος τουλάχιστον 8 χαρακτήρες και να περιέχουν τουλάχιστον 1 αλφάβητο, 1 κεφαλαίο, 1 αριθμητικό και 1 ειδικό χαρακτήρα",
        "newPassword": "Οι νέοι κωδικοί πρόσβασης πρέπει να έχουν μήκος τουλάχιστον 8 χαρακτήρες και να περιέχουν τουλάχιστον 1 αλφάβητο, 1 κεφαλαίο, 1 αριθμητικό και 1 ειδικό χαρακτήρα",
        "currentPasswordValid": "Το τρέχον πεδίο κωδικού πρόσβασης πρέπει να αποτελείται από τουλάχιστον 8 χαρακτήρες",
        "newPasswordValid": "Το πεδίο νέου κωδικού πρόσβασης πρέπει να αποτελείται από τουλάχιστον 8 χαρακτήρες",
        "please_wait_before_resending_email": "Παρακαλώ ελέγξτε το email σας. Εάν δεν το έχετε λάβει, μπορείτε να στείλετε ξανά το email επαλήθευσης μετά από 1 λεπτό."
    },
    "companyErrorMessage": {
        "phoneNumberValid": "Το πεδίο του αριθμού τηλεφώνου πρέπει να έχει τουλάχιστον 10 χαρακτήρες",
        "Something_went_wrong_Please_contact_to_admin": "Κάτι πήγε στραβά. Παρακαλώ επικοινωνήστε με τον διαχειριστή"
    },
    "errorPage": {
        "project_name": "Όνομα έργου",
        "project_key": "Κλειδί έργου",
        "project_category": "Κατηγορία έργου",
        "team_name": "Όνομα ομάδας",
        "The": "Το",
        "field_must_be_a_valid": "Το πεδίο πρέπει να είναι έγκυρο",
        "email": "email",
        "password": "Κωδικός πρόσβασης",
        "first_name": "Όνομα",
        "last_name": "Επώνυμο",
        "company_name": "Όνομα εταιρείας",
        "file_extension": "Κατάληξη αρχείου",
        "milestone_status": "Κατάσταση ορόσημου",
        "name": "Όνομα",
        "phone_number": "Αριθμός τηλεφώνου",
        "field_must_be_at_least": "Το πεδίο πρέπει να έχει τουλάχιστον",
        "number": "αριθμός",
        "characters": "χαρακτήρες",
        "digits": "ψήφια",
        "priority_name": "Όνομα προτεραιότητας",
        "firstName": "Όνομα",
        "lastName": "Επώνυμο",
        "phoneNumber": "Αριθμός τηλεφώνου",
        "amount": "Ποσό",
        "phone": "Τηλέφωνο",
        "country": "Χώρα",
        "state": "Πολιτεία",
        "city": "Πόλη",
        "templatename": "Όνομα προτύπου",
        "description": "Περιγραφή",
        "Template_name_is_required": "Το όνομα προτύπου είναι υποχρεωτικό",
        "This_template_name_is_required.": "Το όνομα προτύπου είναι υποχρεωτικό.",
        "status": "Κατάσταση",
        "zipcode": "ΤΚ",
        "address2": "Διεύθυνση 2",
        "address1": "Διεύθυνση 1",
        "The_confirm_password_field_is_required": "Το πεδίο επιβεβαίωσης κωδικού πρόσβασης είναι υποχρεωτικό",
        "The_confirm_password_confirmation_does_not_match": "Η επιβεβαίωση του κωδικού πρόσβασης δεν ταιριάζει",
        "terms_and_condition": "Όροι και προϋποθέσεις",
        "category_name": "Όνομα κατηγορίας",
        "channel_name": "Όνομα καναλιού",
        "amount_per_hours": "Ποσό ανά ώρα",
        "refundamount": "Ποσό επιστροφής χρημάτων",
        "please_select_template": "Παρακαλώ επιλέξτε πρότυπο",
        "template_name_already_exists": "Το όνομα του προτύπου υπάρχει ήδη",
        "select_a_date": "Επιλέξτε μια ημερομηνία",
        "must_be_less_than": "πρέπει να είναι μικρότερο από",
        "project_duedate": "Η ημερομηνία λήξης του έργου",
        "project_lead_assignee": "Υπεύθυνος έργου",
        "current_password": "τρέχον κωδικό πρόσβασης",
        "new_password": "νέο κωδικό πρόσβασης",
        "confirm_password": "επιβεβαιώστε τον κωδικό πρόσβασης",
        "This_template_name_is_already_exists": "Αυτό το όνομα προτύπου υπάρχει ήδη.",
        "card_name": "Όνομα Κάρτας",
        "topic": "θέμα",
        "target_audience": "στοχευόμενο κοινό",
        "keywords": "λέξεις-κλειδιά",
        "content_purpose": "σκοπός περιεχομένου",
        "product/service": "προϊόν/υπηρεσία",
        "campaign_goals": "στόχοι καμπάνιας",
        "value_proposition": "πρόταση αξίας",
        "objectives": "στόχοι",
        "key_message": "βασικό μήνυμα",
        "problem": "πρόβλημα",
        "context": "περιβάλλον",
        "constraints": "περιορισμοί",
        "main_keyword": "κύρια λέξη-κλειδί",
        "secondary_keywords": "δευτερεύουσες λέξεις-κλειδιά",
        "content_goal": "στόχος περιεχομένου",
        "keyword_list": "λίστα λέξεων-κλειδιών",
        "questions": "ερωτήσεις",
        "product_description": "περιγραφή προϊόντος",
        "feedback_data": "δεδομένα ανατροφοδότησης",
        "survey_questions": "ερωτήσεις έρευνας",
        "project": "έργο",
        "progress_made": "πρόοδος που έγινε",
        "next_steps": "επόμενα βήματα",
        "key_features": "βασικά χαρακτηριστικά",
        "client_type": "τύπος πελάτη",
        "challenges": "προκλήσεις",
        "results": "αποτελέσματα",
        "event_type": "τύπος εκδήλωσης",
        "cta": "κλήση για δράση",
        "campaign_objectives": "στόχοι καμπάνιας",
        "survey_objectives": "στόχοι έρευνας",
        "column_one_name": "όνομα πρώτης στήλης",
        "column_two_name": "όνομα δεύτερης στήλης",
        "column_one_data": "δεδομένα πρώτης στήλης",
        "column_two_data": "δεδομένα δεύτερης στήλης",
        "customer_name": "όνομα πελάτη",
        "email_purpose": "σκοπός email",
        "talking_points": "σημεία συζήτησης",
        "product_name": "όνομα προϊόντος",
        "about_the_product": "σχετικά με το προϊόν",
        "core_problem_it_solves": "βασικό πρόβλημα που λύνει",
        "what_makes_it_different": "τι το κάνει διαφορετικό",
        "the_product_is": "το προϊόν είναι",
        "core_differentiators": "βασικοί διαχωριστές",
        "product/service_benefits": "οφέλη προϊόντος/υπηρεσίας",
        "call_notes": "σημειώσεις κλήσης",
        "call_transcript": "μεταγραφή κλήσης",
        "target_company": "στοχευόμενη εταιρεία",
        "use_case": "περίπτωση χρήσης",
        "customer_challenges": "προκλήσεις πελάτη",
        "territories": "περιοχές",
        "target_industries": "στοχευόμενοι κλάδοι",
        "sales_goals": "στόχοι πωλήσεων",
        "sales_strategies": "στρατηγικές πωλήσεων",
        "transcript": "μεταγραφή",
        "pain_points": "σημεία πόνου",
        "company_type": "τύπος εταιρείας",
        "sales_cycle_stages": "στάδια κύκλου πωλήσεων",
        "sales_methodologies": "μεθοδολογίες πωλήσεων",
        "key_skills": "βασικές δεξιότητες",
        "training_formats": "μορφές εκπαίδευσης",
        "participants": "συμμετέχοντες",
        "target_industry": "στοχευόμενος κλάδος",
        "value_statement": "δήλωση αξίας",
        "meeting_type": "τύπος συνάντησης",
        "your_talking_points": "τα σημεία συζήτησής σας",
        "goal": "στόχος",
        "reasons_for_canceling": "λόγοι ακύρωσης",
        "incentive": "κίνητρο",
        "unique_selling_points": "μοναδικά σημεία πώλησης",
        "desired_format": "επιθυμητή μορφή",
        "topics": "θέματα",
        "content": "περιεχόμενο",
        "stakeholders": "ενδιαφερόμενοι φορείς",
        "sales_notes": "σημειώσεις πωλήσεων",
        "customer_goals": "στόχοι πελάτη",
        "teams_impacted": "ομάδες που επηρεάζονται",
        "requirements": "απαιτήσεις",
        "goals_met": "στόχοι που επιτεύχθηκαν",
        "project_stakeholders": "ενδιαφερόμενοι φορείς έργου",
        "opportunities": "ευκαιρίες",
        "risks": "κίνδυνοι",
        "customer_message": "μήνυμα πελάτη",
        "date_range": "εύρος ημερομηνιών",
        "project_notes": "σημειώσεις έργου",
        "project_description": "περιγραφή έργου",
        "name_of_project": "όνομα έργου",
        "date_ranges": "εύρη ημερομηνιών",
        "requestor": "αιτών",
        "requests": "αιτήσεις",
        "reason_for_the_change": "λόγος για την αλλαγή",
        "expected_impact_of_the_change": "αναμενόμενος αντίκτυπος της αλλαγής",
        "project_goals": "στόχοι έργου",
        "participant_names": "ονόματα συμμετεχόντων",
        "meeting_time": "ώρα συνάντησης",
        "timeline": "χρονοδιάγραμμα",
        "deliverables": "παραδοτέα",
        "project_goal": "στόχος έργου",
        "project_scope": "εμβέλεια έργου",
        "main_task": "κύρια εργασία",
        "new_format": "νέα μορφή",
        "original_text": "αρχικό κείμενο",
        "stakeholder_titles": "τίτλοι ενδιαφερόμενων φορέων",
        "article_title": "τίτλος άρθρου",
        "focus_keywords": "λέξεις-κλειδιά εστίασης",
        "title_of_the_blog_text": "τίτλος κειμένου blog",
        "blog_topic": "θέμα blog",
        "section_title": "τίτλος ενότητας",
        "section_content": "περιεχόμενο ενότητας",
        "section": "ενότητα",
        "title": "τίτλος",
        "title(faq_question)": "τίτλος(ερώτηση FAQ)",
        "issue_description": "περιγραφή ζητήματος",
        "code_section": "ενότητα κώδικα",
        "concept": "έννοια",
        "version": "έκδοση",
        "changes": "αλλαγές",
        "job_title": "τίτλος εργασίας",
        "your_name": "το όνομά σας",
        "your_skills": "οι δεξιότητές σας",
        "math_question": "ερώτηση μαθηματικών",
        "question": "ερώτηση",
        "thesis_topic": "θέμα διπλωματικής",
        "text_to_proofread": "κείμενο προς διόρθωση",
        "text_to_rephrase": "κείμενο προς αναδιατύπωση",
        "text_to_improve": "κείμενο προς βελτίωση",
        "job_description": "περιγραφή εργασίας",
        "your_title": "ο τίτλος σας",
        "your_summary": "η περίληψή σας",
        "pain": "πόνος",
        "agitation": "ταραχή",
        "solution": "λύση",
        "post_content": "περιεχόμενο ανάρτησης",
        "product_or_service": "προϊόν ή υπηρεσία",
        "unique_selling_proposition": "μοναδική πρόταση πώλησης",
        "audiences_objectives": "στόχοι κοινού",
        "email_to_reply_to": "πεδίο email απάντησης",
        "sales_teams_roles": "ρόλοι ομάδας πωλήσεων"
    },
    "Auth": {
        "email": "Email",
        "password": "Κωδικός πρόσβασης",
        "firstName": "Όνομα",
        "lastName": "Επώνυμο",
        "phoneNumber": "Αριθμός τηλεφώνου",
        "login_descriptioon": "Δείτε τι συμβαίνει με την επιχείρησή σας",
        "login_statement": "Συνδεθείτε στον λογαριασμό σας",
        "email_id": "Email ID",
        "Password": "Κωδικός πρόσβασης",
        "Conform_pass": "Επιβεβαίωση κωδικού πρόσβασης",
        "RememberMeL": "Να με θυμάστε",
        "Remember_password": "Να θυμάστε τον κωδικό",
        "Forgot_Password": "Ξεχάσατε τον κωδικό;",
        "loading": "Φόρτωση",
        "loging": "Σύνδεση",
        "Register": "Εγγραφή",
        "NotR": "Δεν είστε εγγεγραμμένοι ακόμα;",
        "createAcc": "Δημιουργήστε έναν λογαριασμό",
        "alredyacc": "Έχετε ήδη λογαριασμό;",
        "ResendEmail": "Αποστολή ξανά του email",
        "pleasecheck": "Παρακαλώ ελέγξτε το email σας, αν δεν το λάβατε ή το χάσατε, κάντε κλικ παρακάτω για να στείλετε ξανά το email.",
        "backlogin": "Επιστροφή στη σύνδεση",
        "Welcome_Msg": "Καλώς ήρθατε στο BRAND_NAME",
        "Welcome_Description": "Αποκτήστε πρόσβαση σε αποκλειστικές δυνατότητες δημιουργώντας έναν λογαριασμό",
        "agree": "Συμφωνώ με τους",
        "tearm": "Όρους Παροχής Υπηρεσιών",
        "and": "και",
        "Privacy_Policy": "Πολιτική Απορρήτου",
        "forgatepasswordmsg": "Εισάγετε το email που σχετίζεται με τον λογαριασμό σας και θα σας στείλουμε ένα email με οδηγίες για την επαναφορά του κωδικού πρόσβασης.",
        "ltitle": "Δουλέψτε σε μεγάλες ιδέες, χωρίς την πολυάσχολη εργασία.",
        "time_format": "Μορφή ώρας",
        "timezone": "Ζώνη ώρας",
        "selectLanguage": "Επιλέξτε Γλώσσα",
        "check_credentials": "Παρακαλώ ελέγξτε τα στοιχεία σύνδεσης σας.",
        "check_smtp_credentials": "Παρακαλώ ελέγξτε τα στοιχεία σύνδεσης SMTP.",
        "smtp_successfully_verified": "Ο SMTP σας επαληθεύθηκε επιτυχώς.",
        "verification_code_invalid": "Ο κωδικός επαλήθευσης είναι άκυρος.",
        "verification_code_invalid_check_code": "Ο κωδικός επαλήθευσης είναι άκυρος. Ελέγξτε τον κωδικό σας.",
        "verification_mail_sent": "Το email επαλήθευσης εστάλη με επιτυχία. Ελέγξτε τα εισερχόμενά σας.",
        "no_account_found_for_email": "Δεν βρέθηκε λογαριασμός για το δεδομένο email.",
        "verify_email_and_try_again": "Επαληθεύστε το email σας και προσπαθήστε ξανά.",
        "confirm_password": "Επιβεβαίωση κωδικού πρόσβασης",
        "enter_new_password": "Παρακαλώ εισάγετε τον νέο σας κωδικό πρόσβασης",
        "link_expired_resend_email": "Ο σύνδεσμός σας έχει λήξει.",
        "reset_password": "Επαναφορά κωδικού πρόσβασης",
        "resend_verification_email": "Παρακαλώ κάντε κλικ στο κουμπί για να στείλετε ξανά το email επαλήθευσης",
        "link_expired": "Αυτός ο σύνδεσμος έχει λήξει",
        "too_many_request": "Έχετε στείλει πάρα πολλά αιτήματα σε σύντομο χρονικό διάστημα. Περιμένετε και προσπαθήστε ξανά αργότερα.",
        "previous_wasnot_valid": "Ο προηγούμενος κωδικός πρόσβασης δεν ήταν έγκυρος. Επαληθεύστε και προσπαθήστε ξανά.",
        "password_wasnot_valid": "Ο νέος σας κωδικός πρόσβασης δεν ήταν έγκυρος. Παρακαλώ προσπαθήστε ξανά.",
        "set_new_password": "Ορισμός νέου κωδικού πρόσβασης",
        "verification_link_expired": "Αυτός ο σύνδεσμος επαλήθευσης έχει λήξει.",
        "verification_link_expired_message": "Παρακαλώ ελέγξτε τα εισερχόμενά σας για το πιο πρόσφατο email επαλήθευσης. Αν δεν το έχετε λάβει, δοκιμάστε να συνδεθείτε ξανά για να ζητήσετε ένα νέο.",
        "oAuthGoogleBtnText": "Συνέχεια με το Google"
    },
    "Home": {
        "unlock": "Ξεκλείδωμα",
        "lock": "Κλείδωμα",
        "dashboardLockSuccess": "Ο πίνακας κλειδώθηκε με επιτυχία",
        "dashboardUnlockSuccess": "Ο πίνακας ξεκλειδώθηκε με επιτυχία",
        "Home": "Αρχική",
        "My_Work": "Η Εργασία Μου",
        "Done": "Ολοκληρώθηκε",
        "To_Do": "Προς Έκπληξη",
        "no_task_found": "Δεν βρέθηκε εργασία",
        "Confirm": "Επιβεβαίωση",
        "tourclose": "Είστε σίγουροι ότι θέλετε να κλείσετε αυτό το τουρ; Αν το επιβεβαιώσετε, δεν θα μπορείτε να αποκτήσετε ξανά πρόσβαση στον οδηγό του τουρ.",
        "Queue_List": "Λίστα Ουράς",
        "AddtoQueue": "Προσθήκη στην Ουρά",
        "noquelist": "Δεν βρέθηκε λίστα ουράς",
        "Due_Date": "Ημερομηνία Λήξης",
        "createQueueTitle": "Δημιουργία Ουράς",
        "Today": "Σήμερα",
        "Calendar": "Ημερολόγιο",
        "Hide": "Απόκρυψη",
        "Overdue": "Καθυστερημένο",
        "Next": "Επόμενο",
        "Unscheduled": "Μη προγραμματισμένο",
        "task_assign_to_you": "εργασία ανατίθεται σε εσάς",
        "Notification_Request": "Αίτημα Ειδοποίησης",
        "no": "Όχι",
        "yes": "Ναι",
        "add_task_type": "Προσθήκη Τύπου Εργασίας",
        "are_you_sure": "Θέλεις να ενεργοποιήσεις τις ειδοποιήσεις από τον περιηγητή;"
    },
    "Header": {
        "Project_Forecasting": "Πρόβλεψη έργου (Σύντομα διαθέσιμο)",
        "Resource_Planning": "Προγραμματισμός πόρων (Σύντομα διαθέσιμο)",
        "Projects": "Έργα",
        "Time_Sheet": "Φύλλο Χρόνου",
        "User_Timesheet": "Φύλλο Χρόνου Χρήστη",
        "project_Timesheet": "Φύλλο Χρόνου Έργου",
        "Workload_Timesheet": "Φύλλο Χρόνου Φορτίου Εργασίας",
        "Tracker_Timesheet": "Φύλλο Χρόνου Παρακολούθησης",
        "Reports": "Αναφορές",
        "Milestone_Report": "Αναφορά Ορόσημου",
        "Time_Forcasting": "Πρόβλεψη χρόνου",
        "Chat": "Συνομιλία",
        "Notification": "Ειδοποίηση",
        "mention": "Αναφορά",
        "Tours": "Τουρ",
        "Logout": "Αποσύνδεση",
        "Mark_all_as_read": "Μάρκαρε όλα ως διαβασμένα",
        "Mark_all_as_complete": "Μάρκαρε όλα ως Ολοκληρωμένα",
        "designation": "Θέση",
        "upgrade_now": "Αναβάθμιση Τώρα",
        "load_more": "Φόρτωση περισσοτέρων",
        "take_tour": "Πάρτε ένα Τουρ",
        "task_details": "Λεπτομέρειες Εργασίας",
        "Comments": "Σχόλια",
        "activity_log": "Αρχείο Δραστηριότητας",
        "time_log": "Αρχείο Χρόνου",
        "mentions": "Αναφορές",
        "Notifications": "Ειδοποιήσεις",
        "no_data_found": "Δεν βρέθηκαν δεδομένα",
        "search_results": "Αποτελέσματα αναζήτησης",
        "my_profile": "Το προφίλ μου",
        "billing_history": "Ιστορικό Χρέωσης",
        "Assignee": "Ανατεθειμένος",
        "Due Date": "Ημερομηνία Λήξης",
        "Priority": "Προτεραιότητα",
        "Key": "Κλειδί",
        "Created Date": "Ημερομηνία Δημιουργίας",
        "Created By": "Δημιουργήθηκε Από",
        "advance_search": "Προηγμένη Αναζήτηση",
        "for_advance_search": "Για Προηγμένη Αναζήτηση",
        "get_more": "Θέλεις περισσότερα;",
        "to_unlock_activity_view": "Για να ξεκλειδώσετε την προβολή δραστηριότητας",
        "AssigneeUserId": "Ανατεθειμένος",
        "DueDate": "Ημερομηνία Λήξης",
        "TaskKey": "Κλειδί Εργασίας",
        "Task_Priority": "Προτεραιότητα Εργασίας",
        "commentCounts": "Συνομιλία",
        "created_by": "Δημιουργήθηκε Από",
        "created_date": "Ημερομηνία Δημιουργίας",
        "create_project": "Δημιουργία Έργου",
        "Company": "Εταιρεία"
    },
    "ProjectDetails": {
        "select_project_category": "Επιλέξτε Κατηγορία Έργου",
        "select_currency": "Επιλέξτε Νόμισμα",
        "description": "Περιγραφή",
        "details": "Λεπτομέρειες",
        "status": "Κατάσταση",
        "assignee": "Ανατεθειμένος",
        "key": "Κλειδί",
        "category": "Κατηγορία",
        "source": "Πηγή",
        "type": "Τύπος",
        "billing_period": "Περίοδος Χρέωσης",
        "currency": "Νόμισμα",
        "amount": "Ποσό",
        "start_date": "Ημερομηνία Έναρξης",
        "end_date": "Ημερομηνία Λήξης",
        "no_start_date": "Δεν υπάρχει ημερομηνία έναρξης",
        "no_end_date": "Δεν υπάρχει ημερομηνία λήξης",
        "no_due_date": "Δεν υπάρχει ημερομηνία λήξης",
        "msg": "Η ημερομηνία έναρξης δεν μπορεί να τροποποιηθεί επειδή είναι ήδη",
        "msgbr": "εντός ενός εύρους ορόσημου.",
        "startdatemsg0": "Η ημερομηνία έναρξης δεν μπορεί να τροποποιηθεί επειδή είναι ήδη",
        "startdatemsg1": "εντός ενός εύρους ορόσημου.",
        "ok": "ΟΚ",
        "lead": "Ηγέτης",
        "browse_by_category": "Περιήγηση κατά κατηγορία",
        "subtask": "Υποεργασία",
        "details_project_setup": "Λεπτομέρειες της ρύθμισης του έργου",
        "avatar": "Αβατάρ",
        "shared_with": "Μοιράστηκε με",
        "no_user_selected": "Δεν έχουν επιλεγεί χρήστες",
        "required_view": "Απαιτούμενες προβολές",
        "set_the_require": "Ορίστε τις απαιτούμενες προβολές. Αυτές οι προβολές θα ορίζονται αυτόματα όταν περιηγείστε σε Έργα, Φάκελοι και Λίστες στο BRAND_NAME αντί να τις δημιουργείτε χειροκίνητα. Μόλις δημιουργηθούν, οι προβολές δεν μπορούν να διαγραφούν.",
        "always_required": "Πάντα απαιτούμενο",
        "make_default": "Ορίστε ως προεπιλογή",
        "reporter": "Αναφορέας",
        "copy_task_link": "Αντιγραφή Συνδέσμου Εργασίας",
        "copy_task_key": "Αντιγραφή Κλειδιού Εργασίας",
        "add_que_list": "Προσθήκη στη Λίστα Ουράς",
        "remove_que_list": "Αφαίρεση από τη Λίστα Ουράς",
        "convert_list": "Μετατροπή σε Λίστα",
        "convert_subtask": "Μετατροπή σε Υποεργασία",
        "merge": "Συγχώνευση",
        "move": "Μετακίνηση",
        "convert_task": "Μετατροπή σε Εργασία",
        "no_currency_found": "Δεν βρέθηκε νόμισμα",
        "remove_from_queue_list": "Αφαίρεση από τη Λίστα Ουράς",
        "convert": "Μετατροπή",
        "DUPLICATE_AND_OPEN": "Διπλασίαση και Άνοιγμα",
        "MOVE_AND_OPEN": "Μετακίνηση και Άνοιγμα",
        "CONVERT_AND_OPEN": "Μετατροπή και Άνοιγμα",
        "MERGE_AND_OPEN": "Συγχώνευση και Άνοιγμα"
    },
    "ProjectSlider": {
        "new_project": "Νέο Έργο",
        "no_archived": "Δεν βρέθηκαν αρχειοθετημένα δεδομένα",
        "you_dont": "Δεν έχετε έργα",
        "archived_list": "Αρχειοθετημένη Λίστα",
        "projects": "Έργα",
        "project_name": "Όνομα Έργου",
        "folder_name": "Όνομα Φακέλου",
        "sprint_name": "Όνομα Sprint",
        "show_archive": "Εμφάνιση Αρχειοθέτησης",
        "hide_archive": "Απόκρυψη Αρχειοθέτησης",
        "try_using_diff": "Δοκιμάστε να χρησιμοποιήσετε διαφορετικές λέξεις-κλειδιά",
        "no_project_found": "Δεν βρέθηκαν έργα",
        "no_result_found": "Δεν βρέθηκαν αποτελέσματα",
        "select_project_status": "Επιλέξτε Κατάσταση Έργου",
        "no_activity_log_found": "Δεν βρέθηκε αρχείο δραστηριότητας"
    },
    "Projects": {
        "sprint": "Sprint",
        "folder": "Φάκελος",
        "task_view": "Προβολή Εργασίας",
        "default_view": "Προεπιλεγμένη Προβολή",
        "add_view": "Προσθήκη Προβολής",
        "rename": "Μετονομασία",
        "pin": "Επικόλληση",
        "edit_code": "Επεξεργασία Κώδικα",
        "copy_link": "Αντιγραφή Συνδέσμου",
        "delete": "Διαγραφή",
        "view": "Προβολή",
        "watchers": "Παρατηρητές",
        "files_links": "Αρχεία & Σύνδεσμοι",
        "audio_files": "Αρχεία Ήχου",
        "project_permissions": "Δικαιώματα Έργου",
        "color_avatar": "Χρώμα & Αβατάρ",
        "duplicate": "Διπλασιασμός",
        "close_project": "Κλείσιμο Έργου",
        "archive": "Αρχειοθέτηση",
        "search_in": "Αναζήτηση Σε",
        "expanded": "Επεκταμένη",
        "collapsed": "Συρρικνωμένη",
        "me": "Εγώ",
        "status": "Κατάσταση",
        "priority": "Προτεραιότητα",
        "due_date": "Ημερομηνία Λήξης",
        "group_by": "Ομαδοποίηση Κατά",
        "subtask": "Υποεργασία",
        "task_name": "Όνομα Εργασίας",
        "task_key": "Κλειδί Εργασίας",
        "everyone": "Όλοι",
        "private": "Ιδιωτικό",
        "share_with": "Μοιραστείτε με",
        "create_new_list": "Δημιουργία Νέου Sprint",
        "create_new_folder": "Δημιουργία Νέου Φακέλου",
        "restore": "Ανάκτηση",
        "unpin": "Αφαίρεση από την Πρόσδεση",
        "pinview": "Επικόλληση Προβολής",
        "deleteview": "Διαγραφή Προβολής",
        "close": "Κλείσιμο",
        "cancel": "Ακύρωση",
        "tasks": "Εργασίες",
        "save": "Αποθήκευση",
        "create_project": "Δημιουργία Έργου",
        "use_template": "Χρήση Προτύπου",
        "blank_project": "Κενό Έργο",
        "no_category_found": "Δεν βρέθηκε κατηγορία",
        "template": "Πρότυπο",
        "save_create": "Αποθήκευση & Δημιουργία",
        "save_tamplete": "Αποθήκευση ως Πρότυπο",
        "previous": "Προηγούμενο",
        "new_task": "Νέα Εργασία",
        "add_subtask": "Προσθήκη Υποεργασίας",
        "list_of_user": "Λίστα Χρηστών",
        "list_of_project_status": "Λίστα Κατάστασης Έργου",
        "list_of_task_type": "Λίστα Τύπου Εργασίας",
        "list_of_task_status": "Λίστα Κατάστασης Εργασίας",
        "list_cc": "Λίστα cc",
        "category_list": "Λίστα Κατηγοριών",
        "created_by": "Δημιουργήθηκε από",
        "tags": "Ετικέτες",
        "task_type": "Τύπος Εργασίας",
        "workspace": "Χώρος Εργασίας",
        "project_color": "Χρώμα Έργου",
        "search": "Αναζήτηση",
        "add_task_need": "Προσθέστε τον τύπο εργασιών που χρειάζεστε",
        "what_task_want": "Τι τύπο εργασίας θέλετε",
        "no_sub_tasks_found": "Δεν βρέθηκαν υποεργασίες",
        "all_project": "Όλα τα Έργα",
        "closed_project": "Κλειστά Έργα",
        "go_to_project": "Μετάβαση σε Έργα",
        "reopen_project": "Άνοιγμα Έργου",
        "required_view": "Απαιτούμενες Προβολές",
        "project_status": "Προσθέστε τις καταστάσεις για το έργο",
        "what_project": "Τι κατάσταση έργου θέλεις",
        "active_status": "Κατάσταση Ενεργού",
        "done_status": "Κατάσταση Ολοκληρωμένο",
        "add_status": "Προσθήκη Κατάστασης",
        "close_status": "Κατάσταση Κλεισίματος",
        "submit": "Υποβολή",
        "Audio_Files": "Αρχεία Ήχου",
        "Files_&_Links": "Αρχεία & Σύνδεσμοι",
        "no_audio_file": "Δεν βρέθηκαν αρχεία ήχου",
        "change_color": "Αλλαγή χρώματος & αβατάρ",
        "files": "Αρχεία",
        "links": "Σύνδεσμοι",
        "about": "Σχετικά",
        "result": "αποτελέσματα",
        "seconds": "δευτερόλεπτα",
        "sort_by": "Ταξινόμηση κατά",
        "relevance": "Σχέση",
        "last_update": "Τελευταία Ενημέρωση",
        "last_created": "Τελευταία Δημιουργία",
        "issue": "Θέμα",
        "update": "Ενημέρωση",
        "date": "Ημερομηνία",
        "time": "Ώρα",
        "duration": "Διάρκεια",
        "duplicate_task": "Διπλασιασμός Εργασίας",
        "projects": "Έργα",
        "browse_projects": "Περιήγηση σε Έργα",
        "location": "Τοποθεσία",
        "add_new": "Προσθήκη Νέου",
        "create_compnay": "Δημιουργία Εταιρείας",
        "company_name": "Όνομα Εταιρείας",
        "archived_project": "Αρχειοθετημένο Έργο",
        "assignee_teams": "Ομάδες Ανατεθειμένων",
        "assignee_user": "Χρήστες Ανατεθειμένων",
        "all": "Όλα",
        "restore_project": "Ανάκτηση Έργου",
        "delete_project": "Διαγραφή Έργου",
        "items_per_page": "Αντικείμενα ανά Σελίδα",
        "Assignee": "Ανατεθειμένος",
        "Project_Created_Date": "Ημερομηνία Δημιουργίας Έργου",
        "Project_Status": "Κατάσταση Έργου",
        "Project_Type": "Τύπος Έργου",
        "Comments_Counts": "Αριθμός Σχολίων",
        "Created_Date": "Ημερομηνία Δημιουργίας",
        "Name": "Όνομα",
        "Running_Time_Tracker": "Παρακολούθηση Χρόνου Εκτέλεσης",
        "Assigned_to": "Ανατεθειμένο σε",
        "Project": "Έργο",
        "Currency": "Νόμισμα",
        "Milestone_Type": "Τύπος Ορόσημου",
        "Project_Category": "Κατηγορία Έργου",
        "Comment_Type": "Τύπος Σχολίου",
        "results_in_time": "Αποτελέσματα σε",
        "create_blank_project": "Δημιουργία Κενό Έργου",
        "create_project_using_template": "Δημιουργία Έργου Χρησιμοποιώντας Πρότυπο",
        "choose_apps": "Επιλέξτε εφαρμογές"
    },
    "Watcher": {
        "ignore": "Αγνόησε",
        "participating_mentions": "Συμμετοχή και αναφορές {'@'}",
        "list_of_watcher": "Λίστα Παρακολουθητών",
        "all_activity": "Όλες οι Δραστηριότητες",
        "watchers_list": "Λίστα Παρακολουθητών",
        "owner": "Ιδιοκτήτης"
    },
    "ViewList": {
        "List": "Λίστα",
        "Board": "Πίνακας",
        "Project Details": "Λεπτομέρειες Έργου",
        "Comments": "Σχόλια",
        "Calendar": "Ημερολόγιο",
        "Activity": "Δραστηριότητα",
        "Workload": "Φορτίο Εργασίας",
        "Gantt": "Γκάνττ",
        "Table": "Πίνακας",
        "Timeline": "Χρονοδιάγραμμα",
        "Embed": "Ενσωμάτωση",
        "Comment": "Σχόλιο",
        "to_unlock_list_view": "Για να ξεκλειδώσετε την προβολή Λίστας",
        "error_message_for_empty": "Παρακαλώ επιλέξτε τουλάχιστον μία προβολή",
        "set_as_default": "Ορισμός ως προεπιλογή",
        "remove_as_default": "Αφαίρεση ως προεπιλογή"
    },
    "Apps": {
        "tags": "Ετικέτες",
        "Priority": "Προτεραιότητα",
        "TimeEstimates": "Εκτιμήσεις Χρόνου",
        "Milestones": "Ορόσημα",
        "MultipleAssignees": "Πολλαπλοί Ανάδοχοι",
        "CustomFields": "Προσαρμοσμένα Πεδία",
        "TimeTracking": "Παρακολούθηση Χρόνου",
        "AI": "Τεχνητή Νοημοσύνη"
    },
    "Tags": {
        "no_tags_found": "Δεν βρέθηκαν ετικέτες",
        "search_or_create_new": "Αναζήτηση ή Δημιουργία Νέας",
        "change_color": "Αλλαγή Χρώματος",
        "delete_tag": "Διαγραφή Ετικέτας",
        "delete_tag_desc": "Είστε σίγουροι ότι θέλετε να διαγράψετε την ετικέτα παντού σε αυτόν τον χώρο;",
        "note_msg": "Πατήστε Enter για να δημιουργήσετε μια νέα ετικέτα",
        "This_tag_has_already_been_added": "Αυτή η ετικέτα έχει ήδη προστεθεί",
        "Tag_name_required": "Απαιτείται το όνομα της ετικέτας"
    },
    "Embeded": {
        "Anything": "Οτιδήποτε",
        "Sheets": "Google Sheets",
        "Docs": "Google Docs",
        "Youtube": "Youtube",
        "Figma": "Figma",
        "The_name_is_required": "Απαιτείται το όνομα",
        "The_name_should_be_at_least_3_characters_long": "Το όνομα πρέπει να έχει τουλάχιστον 3 χαρακτήρες",
        "The_url_is_required": "Απαιτείται η διεύθυνση URL",
        "Please_enter_valid_url": "Παρακαλώ εισάγετε έγκυρη διεύθυνση URL",
        "URL_already_exists": "Η διεύθυνση URL υπάρχει ήδη",
        "The_Html_code_is_required": "Απαιτείται ο κώδικας HTML",
        "name_already_exists": "Αυτό το όνομα υπάρχει ήδη",
        "to_unlock_embed_view": "Για να ξεκλειδώσετε την προβολή Ενσωμάτωσης"
    },
    "ViewListdescription": {
        "list_view": "Χρησιμοποιήστε την προβολή Λίστας για να οργανώσετε τις εργασίες σας με οποιονδήποτε τρόπο φανταστείτε – ταξινομήστε, φιλτράρετε, ομαδοποιήστε και προσαρμόστε τις στήλες.",
        "kanban_view": "Δημιουργήστε τον τέλειο Πίνακα σας και μεταφέρετε εύκολα τις εργασίες μεταξύ των στηλών.",
        "projectdetail_view": "Προσθέστε τις αρχικές απαιτήσεις, τη λίστα ελέγχου και τα αρχεία για να κατανοήσει η ομάδα τις λεπτομέρειες.",
        "Comments_view": "Προσθέστε σχόλια σε πραγματικό χρόνο για οποιοδήποτε θέμα με την ομάδα σας, ώστε να ειδοποιηθούν και να απαντήσουν.",
        "calender_view": "Η προβολή Ημερολογίου είναι το μέρος για τον προγραμματισμό, τη διαχείριση και τον προγραμματισμό πόρων.",
        "table_view": "Διαχειριστείτε εύκολα, ενημερώστε και οργανώστε τις εργασίες σας με την προβολή Πίνακα.",
        "workload_view": "Δείτε την ικανότητα της ομάδας σας, ποιοι είναι υπερφορτωμένοι ή υποφορτωμένοι και αναθέστε εργασίες αναλόγως.",
        "activitylog_view": "Αποκτήστε μια συγκεντρωτική προβολή όλων των δραστηριοτήτων σε μια τοποθεσία. Φιλτράρετε για άτομα και τύπους για να δείτε πιο αναλυτικά τη δραστηριότητα.",
        "add_msg1": "Προσθέστε εφαρμογές και ιστοσελίδες δίπλα στις εργασίες σας με την προβολή Ενσωμάτωσης",
        "add_msg2": "για να εξοικονομήσετε χρόνο και να μειώσετε την εναλλαγή περιβάλλοντος.",
        "view_name": "Όνομα Προβολής",
        "embed_URL": "Ενσωμάτωση URL",
        "embed_HTML": "Ενσωμάτωση HTML",
        "private_view": "Ιδιωτική προβολή"
    },
    "Filters": {
        "filter": "Φίλτρο",
        "learnmorefilter": "Μάθετε περισσότερα για τα φίλτρα",
        "pleaseselectvalid": "Παρακαλώ επιλέξτε όλες τις έγκυρες επιλογές",
        "confirm": "Επιβεβαίωση",
        "are_you_sure": "Είστε σίγουροι ότι θέλετε να διαγράψετε",
        "clearall": "Καθαρισμός όλων",
        "addfilter": "Προσθήκη Φίλτρου",
        "where": "Που",
        "filtering_field": "Πεδίο Φιλτραρίσματος",
        "no_date_found": "Δεν βρέθηκε καμία ημερομηνία",
        "save_this_filters": "Αποθήκευση αυτών των φίλτρων",
        "save_filter": "Αποθήκευση φίλτρου",
        "save": "Αποθήκευση",
        "update_filter": "Ενημέρωση φίλτρου",
        "my_filter": "Το φίλτρο μου",
        "no_data_found": "Δεν βρέθηκαν δεδομένα",
        "show_result": "Εμφάνιση αποτελέσματος",
        "save_filters": "Αποθήκευση φίλτρων",
        "filter_by": "Φιλτράρισμα κατά",
        "projects": "Έργα",
        "teams": "Ομάδες",
        "user": "Χρήστης",
        "no_comment_found": "Δεν βρέθηκαν σχόλια",
        "no_project_found": "Δεν βρέθηκαν έργα",
        "no_file_found": "Δεν βρέθηκαν αρχεία",
        "no_link_found": "Δεν βρέθηκαν σύνδεσμοι",
        "filter_operator": "Τελεστής φίλτρου",
        "options": "Επιλογές",
        "priorities": "Προτεραιότητες",
        "select_all": "Επιλογή όλων",
        "milestone_type": "Τύπος Ορόσημου",
        "comment_type": "Τύπος Σχολίου",
        "a_to_z": "Α προς Ω",
        "no_files_found": "Δεν βρέθηκαν αρχεία",
        "no_links_found": "Δεν βρέθηκαν σύνδεσμοι",
        "no_links_or_files_found": "Δεν βρέθηκαν σύνδεσμοι ή αρχεία",
        "z_to_a": "Ω προς Α",
        "sort_by": "Ταξινόμηση κατά",
        "A-Z": "Α-Ω",
        "Ascending": "Αύξουσα",
        "Descending": "Φθίνουσα",
        "No": "Όχι",
        "Yes": "Ναι",
        "Z-A": "Ω-Α",
        "Save_this_Filter": "Αποθήκευση αυτού του φίλτρου",
        "Enter_Filter_Name": "Εισάγετε το όνομα φίλτρου",
        "Select_Options": "Επιλέξτε Επιλογές",
        "Equal_To": "Ίσο με",
        "Greater_Than": "Μεγαλύτερο από",
        "Is": "Είναι",
        "Less_Than": "Λιγότερο από",
        "Clear_All": "Καθαρισμός όλων",
        "select_assignee": "Επιλέξτε Ανάδοχο",
        "select_project_types": "Επιλέξτε Τύπους Έργων",
        "unselect_all": "Αποεπιλογή όλων",
        "are_you_suredelete": "Είστε σίγουροι ότι θέλετε να διαγράψετε;",
        "Not_Equals_To": "Δεν είναι"
    },
    "conformationmsg": {
        "archive": "Μια Λίστα μπορεί να αρχειοθετηθεί για να κρυφτεί από την προβολή αλλά να αποκατασταθεί οποιαδήποτε στιγμή. Όλες οι εργασίες παραμένουν αναζητήσιμες όταν αρχειοθετείτε μια Λίστα.",
        "delete": "Οι εργασίες και τα πρότυπα αυτού του έργου θα διαγραφούν όλα. Πληκτρολογήστε το όνομα του έργου για να επιβεβαιώσετε ότι πραγματικά θέλετε να διαγράψετε όλες τις εργασίες, τα πρότυπα και το έργο.",
        "archive0mesg": "Πληκτρολογήστε το όνομα του έργου για να επιβεβαιώσετε ότι πραγματικά θέλετε να κλείσετε αυτό το έργο",
        "sprintclosemsg": "Πληκτρολογήστε το όνομα της σπριντ για να επιβεβαιώσετε ότι πραγματικά θέλετε να κλείσετε αυτήν τη σπριντ",
        "type": "Τύπος",
        "are_you_sure": "Είστε σίγουροι;",
        "no_revert_msg": "Δεν θα μπορείτε να το επαναφέρετε!",
        "yes_delete": "Ναι, διαγράψτε το!",
        "task_will_become_subtasks_of": "Η εργασία θα γίνει υποεργασίες του",
        "Are_you_sure_you_want_to_delete": "Είστε σίγουροι ότι θέλετε να διαγράψετε",
        "subtasks_will_become_subtasks_of": "Οι υποεργασίες θα γίνουν υποεργασίες του",
        "unlock_board_view": "Για να ξεκλειδώσετε την προβολή Πίνακα",
        "unlock_project_detail_view": "Για να ξεκλειδώσετε την προβολή Λεπτομερειών Έργου",
        "unlock_table_view": "Για να ξεκλειδώσετε την προβολή Πίνακα",
        "unlock_workload_view": "Για να ξεκλειδώσετε την προβολή Φορτίου Εργασίας",
        "to_unlock_tracker_timesheet": "Για να ξεκλειδώσετε το Χρονολόγιο Παρακολούθησης",
        "to_unlock_user_timesheet": "Για να ξεκλειδώσετε το Χρονολόγιο Χρήστη",
        "unlock_calendar_view": "Για να ξεκλειδώσετε την προβολή Ημερολογίου"
    },
    "Description": {
        "description": "Περιγραφή",
        "edit": "Επεξεργασία",
        "add_description": "Προσθήκη Περιγραφής",
        "show_more": "Δείξτε Περισσότερα",
        "show_less": "Δείξτε Λιγότερα",
        "description_placeholder": "Γράψτε κάτι ή πληκτρολογήστε '/' για εντολές και ενέργειες AI",
        "saved": "Αποθηκευμένο"
    },
    "Checklist": {
        "checklist": "Λίστα Ελέγχου",
        "add_checklist": "Προσθήκη Λίστας Ελέγχου",
        "suggest_checklists": "Προτάσεις για Λίστες Ελέγχου",
        "Checklists": "Λίστες Ελέγχου",
        "to_unlock_checklist": "Για να ξεκλειδώσετε τη Λίστα Ελέγχου"
    },
    "Attachments": {
        "attachments": "Συνημμένα",
        "drag_file": "Εδώ, μπορείτε επίσης να σύρετε και να αποθέσετε αρχεία.",
        "see_all": "Δείτε Όλα",
        "drop_file": "Αφήστε αρχεία εδώ για επισύναψη ή",
        "browse": "Περιήγηση",
        "no_preview_found": "Δεν βρέθηκε προεπισκόπηση",
        "show_all_pages": "Εμφάνιση όλων των σελίδων",
        "drop_here": "Αφήστε Εδώ"
    },
    "Milestone": {
        "milestone": "Ορόσημο",
        "milestone_name": "Όνομα Ορόσημου",
        "status_date": "Ημερομηνία Κατάστασης",
        "total_amount": "Συνολικό Ποσό",
        "are_you_sure": "Είστε σίγουροι ότι θέλετε να διαγράψετε το ορόσημο;",
        "add_new": "Προσθήκη Νέου",
        "mileston_status": "Κατάσταση Οροσήμου",
        "project_name": "Όνομα Έργου",
        "end_date": "Ημερομηνία Λήξης",
        "start_date": "Ημερομηνία Έναρξης",
        "estimated_release": "Εκτιμώμενη Κυκλοφορία",
        "release_request_sent": "Αίτημα Κυκλοφορίας Απεσταλμένο",
        "released": "Απελευθερωμένο",
        "not_funded": "Μη Χρηματοδοτούμενο",
        "funded": "Χρηματοδοτούμενο",
        "project_milestone_Status": "Κατάσταση Οροσήμου Έργου",
        "milestone_status_name": "Όνομα Κατάστασης Οροσήμου",
        "date_displaye": "Ημερομηνία Εμφάνισης στο Ημερολόγιο",
        "past": "Παρελθόν",
        "feature": "Μέλλον",
        "milestone_weekly_range": "Εβδομαδιαίο Εύρος Οροσήμου",
        "file_extensions": "Επεκτάσεις Αρχείων",
        "avatar": "Αβατάρ",
        "adding_estimated": "Προσθήκη Εκτιμώμενων Ωρών",
        "range": "Εύρος",
        "user": "Χρήστης",
        "refunded_amount": "Ποσό Επιστροφής",
        "Max_2_decimal_places_allowed": "Μέγιστο 2 δεκαδικά ψηφία επιτρέπονται",
        "The_refunded_amount_field_should_not_be_more_then_amount": "Το πεδίο επιστροφής χρημάτων δεν πρέπει να είναι μεγαλύτερο από το ποσό",
        "Amount_field_should_not_be_smaller_than_the_refunded_amount": "Το πεδίο ποσού δεν πρέπει να είναι μικρότερο από το ποσό επιστροφής",
        "The_minute_field_must_be_59_or_less": "Το πεδίο λεπτών πρέπει να είναι 59 ή λιγότερο",
        "The_hours_field_is_required": "Το πεδίο ωρών είναι υποχρεωτικό",
        "Name_already_exists": "Το όνομα υπάρχει ήδη",
        "The_milestone_status_field_is_required": "Το πεδίο κατάστασης ορόσημου είναι υποχρεωτικό",
        "The_milestone_status_field_must_be_at_leat_3_characters": "Το πεδίο κατάστασης ορόσημου πρέπει να έχει τουλάχιστον 3 χαρακτήρες",
        "actual_amount": "Πραγματικό Ποσό",
        "partially_refunded": "Μερική Επιστροφή",
        "refunded_amount_should_not_exceed_amount": "Το πεδίο επιστροφής χρημάτων δεν πρέπει να υπερβαίνει το ποσό",
        "total_partially_refunded": "Συνολική Μερική Επιστροφή",
        "field_should_not_be_smaller_than_refund_amount": "Το πεδίο δεν πρέπει να είναι μικρότερο από το ποσό επιστροφής",
        "white_color_not_allowed": "Δεν επιτρέπεται το λευκό χρώμα. Επιλέξτε έγκυρο χρώμα",
        "billing": "Τιμολόγηση",
        "per_hour": "Ανά Ώρα",
        "adding_taskPlanning": "Προσθήκη προγραμματισμού εργασιών"
    },
    "Comment": {
        "created_by": "Δημιουργήθηκε από",
        "created_on": "Δημιουργήθηκε στις",
        "task_name": "Όνομα Εργασίας"
    },
    "UserTimesheet": {
        "back_projects": "Πίσω στα Έργα",
        "user_timesheet": "Χρονολόγιο Χρήστη",
        "back": "Πίσω",
        "tracked_time": "Καταγεγραμμένος Χρόνος",
        "manual_time": "Χρόνος Χειροκίνητης Καταγραφής",
        "users": "Χρήστες",
        "logged": "Καταχωρημένο",
        "hours": "Ώρες",
        "estimated": "Εκτιμώμενος",
        "no_records_found": "Δεν βρέθηκαν αρχεία",
        "project_timesheet": "Χρονολόγιο Έργου",
        "tracker_timesheet": "Χρονολόγιο Παρακολούθησης",
        "workload_timesheet": "Χρονολόγιο Φορτίου Εργασίας",
        "milestone_reports": "Αναφορές Οροσήμων",
        "add_time": "Προσθήκη Χρόνου",
        "add_time_log": "Προσθήκη Καταγραφής Χρόνου",
        "edit_time_log": "Επεξεργασία Καταγραφής Χρόνου",
        "Teams": "Ομάδες",
        "Users": "Χρήστες",
        "Projects": "Έργα",
        "task_planning": "Προγραμματισμός εργασιών",
        "task_remaining_planning": "Υπολειπόμενες ώρες",
        "planned": "Προγραμματισμένο"
    },
    "ProjectWorkplace": {
        "msg1": "Το έργο μπορεί να κοινοποιηθεί σε μέλη. Μπορείτε να προσθέσετε επισκέπτες σε Φακέλους, Λίστες και Εργασίες μετά τη δημιουργία του έργου.",
        "msg2": "Προς το παρόν, δεν υπάρχουν σχέδια για τη δημιουργία ιδιωτικών ή δημόσιων έργων. Εάν θέλετε να ξεκινήσετε ένα έργο, θα χρειαστεί να αναβαθμίσετε το πλάνο σας."
    },
    "CustomField": {
        "custom_field": "Προσαρμοσμένο Πεδίο",
        "create_custom_field": "Δημιουργία Προσαρμοσμένου Πεδίου",
        "lable": "Ετικέτα",
        "action": "Ενέργεια",
        "add_custom_field": "Προσθήκη Προσαρμοσμένου Πεδίου",
        "add_new_custom_field": "Προσθήκη Νέου Προσαρμοσμένου Πεδίου",
        "field_name": "Όνομα Πεδίου",
        "date_created": "Ημερομηνία Δημιουργίας",
        "add_another_item": "Προσθήκη άλλου στοιχείου",
        "choose_ready_made_list": "Επιλέξτε μια έτοιμη λίστα επιλογών (π.χ. ημέρες, μήνες κ.λπ.)",
        "predefined_options": "Προκαθορισμένες Επιλογές",
        "selected_by_default": "Επιλεγμένο από Προεπιλογή",
        "allow_time_with_date": "Επιτρέπεται στους χρήστες να προσδιορίσουν ώρα με ημερομηνία.",
        "date_format": "Μορφή Ημερομηνίας",
        "days_of_week": "Ημέρες της εβδομάδας",
        "past_and_future": "Παρελθόν & Μέλλον",
        "select_date_format": "Επιλέξτε μια μορφή ημερομηνίας. Το D σημαίνει ημέρα, το M για μήνα και το Y για έτος.",
        "select_dates_past_future": "Επιτρέψτε στους χρήστες να επιλέγουν ημερομηνίες στο παρελθόν ή στο μέλλον",
        "select_time_format": "Επιλέξτε μορφή ώρας",
        "time_format": "Μορφή Ώρας",
        "unchecking_day_calendar": "Η αποεπιλογή μιας ημέρας θα την καταστήσει μη διαθέσιμη στο ημερολόγιο",
        "future": "Μέλλον",
        "past": "Παρελθόν",
        "enter_maximum_limit": "Εισάγετε Μέγιστο Όριο",
        "enter_minimum_limit": "Εισάγετε Ελάχιστο Όριο",
        "limit_minimum_or_maximum_value": "Περιορίστε την ελάχιστη ή μέγιστη τιμή που επιτρέπεται για αυτό το πεδίο",
        "maximum_limit_type_not_allowed_value": "Η εισαγόμενη τιμή για τον τύπο μέγιστου ορίου δεν είναι επιτρεπτή.",
        "maximum_value_should_be_greater_than_minimum_value": "Η μέγιστη τιμή πρέπει να είναι μεγαλύτερη από την ελάχιστη τιμή",
        "minimum_limit_type_not_allowed_value": "Η εισαγόμενη τιμή για τον τύπο ελάχιστου ορίου δεν είναι επιτρεπτή.",
        "minimum_value_should_not_be_greater_than_maximum_value": "Η ελάχιστη τιμή δεν πρέπει να είναι μεγαλύτερη από τη μέγιστη τιμή",
        "no_country_found": "Δεν βρέθηκε χώρα",
        "enter_maximum_limit_type": "Εισάγετε τον Τύπο Μέγιστου Ορίου",
        "enter_minimum_limit_type": "Εισάγετε τον Τύπο Ελάχιστου Ορίου",
        "limit_minimum_or_maximum_text_allowed": "Περιορίστε την ελάχιστη ή μέγιστη ποσότητα κειμένου που επιτρέπεται σε αυτό το πεδίο",
        "max_should_be_greater_than_min": "Η μέγιστη τιμή πρέπει να είναι μεγαλύτερη από την ελάχιστη",
        "min_should_be_less_than_max": "Η ελάχιστη τιμή πρέπει να είναι μικρότερη από τη μέγιστη",
        "separator": "Διαχωριστικό",
        "countryCode": "Ενεργοποιήστε το για να τροποποιήσετε τον κωδικό χώρας."
    },
    "Category": {
        "cateory_name": "Όνομα Κατηγορίας",
        "create_category": "Δημιουργία Κατηγορίας",
        "create_channel": "Δημιουργία Καναλιού",
        "no_chat_found": "Δεν βρέθηκαν συνομιλίες",
        "upgradeplanemsg": "Για να αποκτήσετε πρόσβαση σε αυτήν τη λειτουργία, παρακαλούμε αναβαθμίστε το πλάνο σας."
    },
    "Channel": {
        "create_channel": "Δημιουργία Καναλιού",
        "msg1": "Έχετε φτάσει το όριο δημιουργίας δημόσιων και ιδιωτικών καναλιών. Για να αποκτήσετε πρόσβαση σε αυτήν τη λειτουργία, παρακαλούμε αναβαθμίστε το πλάνο σας.",
        "channel_name": "Όνομα Καναλιού",
        "icons": "Εικονίδια",
        "or": "ή",
        "only_share_with": "Μοιραστείτε μόνο με",
        "private_channel": "Ιδιωτικό Κανάλι",
        "msg2": "Μόνο τα επιλεγμένα μέλη και ρόλοι θα μπορούν να δουν αυτό το κανάλι",
        "allowmsg2": "Επιτρέπει στα μέλη να στέλνουν μηνύματα σε αυτό το κανάλι",
        "send_messages": "Αποστολή Μηνυμάτων",
        "choose_to_upload": "Επιλέξτε μια εικόνα για να ανεβάσετε",
        "private_channel_limit_reached": "Έχετε φτάσει το όριο δημιουργίας ιδιωτικών καναλιών. Μπορείτε να δημιουργήσετε μόνο δημόσια κανάλια. Εάν θέλετε να δημιουργήσετε ένα ιδιωτικό κανάλι, παρακαλούμε αναβαθμίστε το πλάνο σας.",
        "public_channel_limit_reached": "Έχετε φτάσει το όριο δημιουργίας δημόσιων καναλιών. Μπορείτε να δημιουργήσετε μόνο ιδιωτικά κανάλια. Εάν θέλετε να δημιουργήσετε ένα δημόσιο κανάλι, παρακαλούμε αναβαθμίστε το πλάνο σας."
    },
    "Templates": {
        "delete_template": "Διαγραφή Προτύπου",
        "project_status": "Κατάσταση Έργου",
        "task_status": "Κατάσταση Εργασίας",
        "no_app_selected": "Δεν έχουν επιλεγεί εφαρμογές",
        "default_views": "Προεπιλεγμένες Ρυθμίσεις για Προβολές",
        "apps": "Εφαρμογές",
        "add_new_templete": "Προσθήκη Νέου Προτύπου",
        "templates": "Πρότυπα",
        "s": "s",
        "template_name": "Όνομα Προτύπου",
        "upload_image": "Ανέβασμα Εικόνας",
        "all_good": "Όλα εντάξει",
        "create_template": "Δημιουργία Προτύπου",
        "new_template": "Νέο Πρότυπο",
        "remove": "Αφαίρεση",
        "enable_apps": "Ενεργοποίηση Εφαρμογών",
        "Turn": "Ενεργοποίηση",
        "all_apps": "όλες οι εφαρμογές",
        "off": "απενεργοποιημένο",
        "on": "ενεργοποιημένο",
        "upload": "Ανέβασμα",
        "save_template": "Αποθήκευση Προτύπου",
        "setup_status": "Ρύθμιση των καταστάσεων για τις εργασίες",
        "what_task": "Ποια κατάσταση εργασίας θέλετε;",
        "select_task_status": "Επιλέξτε Κατάσταση Εργασίας",
        "delete_template_confirmation": "Είστε σίγουροι ότι θέλετε να διαγράψετε το πρότυπο;",
        "ai_sidebar_title": "Δημιουργία προτύπου με AI",
        "ai_label_category": "Κατηγορία",
        "ai_label_description": "Περιγραφή",
        "ai_button_text_requested_changes": "Αίτηση αλλαγών",
        "ai_min_view_msg_text": "Απαιτείται τουλάχιστον μία προβολή",
        "ai_min_msg_text": "Απαιτούνται τουλάχιστον 10 χαρακτήρες",
        "ai_before_desc_placeholder": "Εισάγετε περιγραφή περίπτωσης χρήσης για δημιουργία προτύπου",
        "ai_after_desc_placeholder": "Μπορείτε να συνεχίσετε να ζητάτε σχετικά αιτήματα για αλλαγές",
        "try_with_ai": "Δοκιμάστε με AI",
        "msg_search_result_found": "Ακολουθούν ορισμένα προτεινόμενα πρότυπα που σχετίζονται με τις απαιτήσεις σας. Μπορείτε να επιλέξετε οποιοδήποτε ή να κάνετε απλώς κλικ για να δημιουργήσετε με τεχνητή νοημοσύνη",
        "msg_search_result_not_found": "Δεν βρέθηκαν σχετικά πρότυπα. Για να δημιουργήσετε ένα με τεχνητή νοημοσύνη, απλώς κάντε κλικ"
    },
    "Settings": {
        "add_new_projects": "Προσθήκη Νέου Έργου",
        "task_priority": "Προτεραιότητα Εργασίας",
        "maximum_image_size": "Μέγιστο Μέγεθος Εικόνας",
        "warning": "Προειδοποίηση",
        "cant_delete": "δεν μπορείτε να διαγράψετε",
        "priority_in_use": "Ο χρήστης δεν μπορεί να διαγράψει την προτεραιότητα PRIORITY_NAME καθώς ήδη χρησιμοποιείται.",
        "company_name": "Όνομα Εταιρείας",
        "phone": "Τηλέφωνο",
        "country": "Χώρα",
        "state": "Πολιτεία",
        "city": "Πόλη",
        "select_date_format": "Επιλέξτε Μορφή Ημερομηνίας",
        "save_changes": "Αποθήκευση Αλλαγών",
        "currencies": "Νομίσματα",
        "add_remove_cur": "Προσθήκη/Αφαίρεση Νομισμάτων",
        "change_image": "Αλλαγή Εικόνας",
        "Priorities_already_Exists": "Οι προτεραιότητες υπάρχουν ήδη",
        "The_priority_image_field_is_required": "Το πεδίο εικόνας προτεραιότητας είναι υποχρεωτικό",
        "The_priority_name_field_is_required": "Το πεδίο ονόματος προτεραιότητας είναι υποχρεωτικό",
        "The_priority_name_field_must_be_at_least": "Το πεδίο ονόματος προτεραιότητας πρέπει να έχει τουλάχιστον 3 χαρακτήρες",
        "The file extension field is required": "Το πεδίο επέκτασης αρχείου είναι υποχρεωτικό",
        "The_file_extension_field_must_be_at_least": "Το πεδίο επέκτασης αρχείου πρέπει να έχει τουλάχιστον 3 χαρακτήρες",
        "file_extension_is_not_supported": "Η επέκταση αρχείου δεν υποστηρίζεται",
        "file_extension_already_Exists": "Η επέκταση αρχείου υπάρχει ήδη",
        "The_file_extension_field_is_required": "Το πεδίο επέκτασης αρχείου είναι υποχρεωτικό"
    },
    "Members": {
        "invite": "Πρόσκληση",
        "all_members": "Όλα τα μέλη",
        "removed_members": "Αφαιρεμένα μέλη",
        "name": "Όνομα",
        "role": "Ρόλος",
        "last_active": "Τελευταία Ενεργότητα",
        "time_tracker": "Χρονομέτρηση",
        "settings": "Ρυθμίσεις",
        "removeuser": "Αφαίρεση Χρήστη",
        "adduser": "Προσθήκη Χρήστη",
        "invite_user": "Πρόσκληση Χρήστη",
        "remove_request": "Αίτημα Αφαίρεσης",
        "resend_invitation": "Αποστολή Πρόσκλησης Ξανά",
        "cancel_invitation": "Ακύρωση Πρόσκλησης",
        "Invitation_mail_sent_sucessfully": "Η πρόσκληση στάλθηκε επιτυχώς",
        "confirm_change_user_designation": "Είστε σίγουροι ότι θέλετε να αλλάξετε τον τίτλο αυτού του χρήστη σε",
        "confirm_change_user_role": "Είστε σίγουροι ότι θέλετε να αλλάξετε τον ρόλο αυτού του χρήστη σε",
        "Import_users_from_csv": "Εισαγωγή χρηστών από CSV"
    },
    "Upgrades": {
        "take_next_step": "Πάρτε το επόμενο βήμα με την εργασία σας",
        "you_are_on": "Είστε αυτή τη στιγμή στο",
        "per_year": "Ανά έτος",
        "per_month": "Ανά μήνα",
        "current_plane": "Τρέχον Πλάνο",
        "per_member": "Ανά Μέλος",
        "and_much_more": "και πολλά άλλα",
        "upgrade_to": "Αναβάθμιση σε",
        "select_payment_method": "Επιλέξτε Μέθοδο Πληρωμής",
        "plan": "Πλάνο",
        "plane_upgrade": "Αναβάθμιση Πλάνου Επιτυχής",
        "plane_upgrade_msg": "Η αναβάθμιση του πλάνου ήταν επιτυχής! Η συνδρομή σας αναβαθμίστηκε. Παρακαλώ επιτρέψτε 2-3 λεπτά για να ισχύσουν οι αλλαγές παντού, διασφαλίζοντας ότι θα απολαύσετε πλήρως τα επεκταμένα χαρακτηριστικά και βελτιώσεις!",
        "something_wrong": "Κάτι πήγε στραβά. Παρακαλώ δοκιμάστε ξανά",
        "unsucessfull_msg": "Η αναβάθμιση του πλάνου απέτυχε. Εμφανίστηκε πρόβλημα κατά την αναβάθμιση του πλάνου σας. Παρακαλώ δοκιμάστε ξανά ή επικοινωνήστε με την υποστήριξη για βοήθεια.",
        "upgrade_your_plan": "Αναβαθμίστε το Πλάνο σας",
        "to_unlock_custom_field": "Για να Ξεκλειδώσετε το Προσαρμοσμένο Πεδίο",
        "unlimited": "Απεριόριστο",
        "the_feature_not_available": "Αυτό το χαρακτηριστικό δεν είναι διαθέσιμο στο τρέχον πλάνο σας",
        "unlock_project_permission": "Για να Ξεκλειδώσετε τα Δικαιώματα Έργου",
        "unlock_custom_field": "Για να Ξεκλειδώσετε το Προσαρμοσμένο Πεδίο",
        "to_unlock_milestone": "Για να Ξεκλειδώσετε τον Σταθμό Ορόσημο",
        "to_unlock_milestone_report": "Για να Ξεκλειδώσετε την Αναφορά Σταθμού Ορόσημου",
        "to_unlock_security": "Για να Ξεκλειδώσετε την Ασφάλεια & Δικαιώματα",
        "to_unlock_team": "Ξεκλείδωμα ομάδας",
        "to_unlcok_project": "Για να Ξεκλειδώσετε το Έργο",
        "You_have_reached_the_free_plan_limit": "Έχετε φτάσει το όριο του PLAN_NAME",
        "require_upgrade_message": " Μπορείτε να δημιουργήσετε έως PROJECT_COUNT έργα στο πλάνο PROJECT_NAME. Δημιουργήστε περισσότερους πίνακες αναβαθμίζοντας το πλάνο σας.",
        "are_you_sure_you_want_to_update": "Είστε σίγουροι ότι θέλετε να ενημερώσετε;",
        "find_out_whats_included_in_this_update": "Δείτε τι περιλαμβάνεται σε αυτήν την ενημέρωση",
        "improved_performance": "Βελτιωμένη Απόδοση",
        "install_now": "Εγκαταστήστε Τώρα",
        "later": "Αργότερα",
        "please_see_below_for_a_list_of_changes_to_the_features": "Δείτε παρακάτω τη λίστα με τις αλλαγές στα χαρακτηριστικά.",
        "to_integrate_new_services_into_an_alian_hub": "Για να ενσωματώσετε νέες υπηρεσίες στο Hyphen OI Pro.",
        "whats_new": "Τι είναι νέο;",
        "check_to_agree_with_above_points": "Επιλέξτε για να συμφωνήσετε με τα παραπάνω σημεία",
        "general_notes": "Γενικές Σημειώσεις",
        "update_now": "Ενημέρωση Τώρα",
        "unlock_channel": "Για να Ξεκλειδώσετε το Κανάλι",
        "unlock_chat": "Για να Ξεκλειδώσετε την Συνομιλία",
        "unlock_one_chat": "Για να Ξεκλειδώσετε την Συνομιλία One to One",
        "public_private_creation_time_limit_reached": "Έχετε φτάσει το όριο δημιουργίας έργων. Εάν θέλετε να δημιουργήσετε ένα έργο, αναβαθμίστε το πλάνο σας.",
        "public_creation_time_limit_reached": "Έχετε φτάσει το όριο δημιουργίας δημόσιων έργων. Μπορείτε να δημιουργήσετε μόνο ιδιωτικά έργα. Εάν θέλετε να δημιουργήσετε ένα δημόσιο έργο, αναβαθμίστε το πλάνο σας.",
        "private_creation_time_limit_reached": "Έχετε φτάσει το όριο δημιουργίας ιδιωτικών έργων. Μπορείτε να δημιουργήσετε μόνο δημόσια έργα. Εάν θέλετε να δημιουργήσετε ένα ιδιωτικό έργο, αναβαθμίστε το πλάνο σας."
    },
    "Permissions": {
        "advanced_permission": "Προηγμένα Δικαιώματα",
        "allow_admins": "Επιτρέψτε στους διαχειριστές να διαχειρίζονται ιδιωτικούς Χώρους",
        "when_admin_enable": "Όταν ενεργοποιηθεί, οι διαχειριστές θα μπορούν να προσθέτουν/αφαιρούν άτομα και να μεταφέρουν την ιδιοκτησία όλων των Χώρων.",
        "show_all_projects": "Εμφάνιση όλων των έργων",
        "when_user_enable": "Όταν ενεργοποιηθεί, οι χρήστες θα μπορούν να βλέπουν όλα τα παγκόσμια έργα.",
        "show_all_task": "Εμφάνιση όλων των εργασιών",
        "when_user_enable_sprint": "Όταν ενεργοποιηθεί, οι χρήστες θα μπορούν να βλέπουν όλες τις εργασίες στους σπριντ.",
        "own": "Ιδιοκτησία",
        "select": "Επιλογή",
        "Member": "Μέλος",
        "Guest": "Επισκέπτης",
        "None": "Καμία",
        "Read": "Ανάγνωση",
        "add_new_team": "Προσθήκη Νέας Ομάδας",
        "Read & Write": "Ανάγνωση & Εγγραφή",
        "Support": "Υποστήριξη",
        "select_priorities": "Επιλογή Προτεραιοτήτων",
        "apply_permission": "Εφαρμογή Δικαιώματος",
        "project_permission_description": "Για να παρακάμψετε τα παγκόσμια δικαιώματα, είναι απενεργοποιημένο από προεπιλογή. Αφού ενεργοποιηθεί, μπορείτε να διαχειριστείτε τα δικαιώματα έργου και εργασίας. Εάν είναι απενεργοποιημένο, εφαρμόζονται τα παγκόσμια δικαιώματα.",
        "project_permission_title_disable": "Η δυνατότητα παραχώρησης προσαρμοσμένων δικαιωμάτων για αυτό το έργο θα απενεργοποιηθεί",
        "project_permission_title_enable": "Η δυνατότητα παραχώρησης προσαρμοσμένων δικαιωμάτων για αυτό το έργο θα ενεργοποιηθεί",
        "reset_permission": "Επαναφορά Δικαιωμάτων"
    },
    "subProjectRulesNames": {
        "Project_List": "Λίστα Έργων",
        "Project_Create": "Δημιουργία Έργου",
        "Project_Name_Edit": "Επεξεργασία Ονόματος Έργου",
        "Project_Sprint_Create": "Δημιουργία Σπριντ Έργου",
        "Project_folder_Create": "Δημιουργία Φακέλου Έργου",
        "Project_folder_Name_Edit": "Επεξεργασία Ονόματος Φακέλου Έργου",
        "Project_sprint_Name_Edit": "Επεξεργασία Ονόματος Σπριντ Έργου",
        "Project_Details": "Λεπτομέρειες Έργου",
        "Project_Status_Change": "Αλλαγή Κατάστασης Έργου",
        "Project_Assignee": "Αναθέτης Έργου",
        "Project_Category": "Κατηγορία Έργου",
        "Proejct_Source": "Πηγή Έργου",
        "Project_Type": "Τύπος Έργου",
        "Project_Currency": "Νόμισμα Έργου",
        "Project_Amount": "Ποσό Έργου",
        "Project_Start Date": "Ημερομηνία Έναρξης Έργου",
        "Project_End Date": "Ημερομηνία Λήξης Έργου",
        "Project_Due Date": "Ημερομηνία Ολοκλήρωσης Έργου",
        "Project_Close": "Κλείσιμο Έργου",
        "Project_Description": "Περιγραφή Έργου",
        "Project_Checklist": "Λίστα Ελέγχου Έργου",
        "Project_Checklist_Assign/remove": "Ανάθεση/Αφαίρεση Λίστας Ελέγχου Έργου",
        "Project_Attachments": "Επισυνάψεις Έργου",
        "Project_Milestone": "Σταθμός Έργου",
        "Task_list": "Λίστα Εργασιών",
        "Task_Create": "Δημιουργία Εργασίας",
        "Sub_Task_Create": "Δημιουργία Υποεργασίας",
        "Task_Name_Edit": "Επεξεργασία Ονόματος Εργασίας",
        "Task_Status": "Κατάσταση Εργασίας",
        "Task_Assignee": "Αναθέτης Εργασίας",
        "Task_Priority": "Προτεραιότητα Εργασίας",
        "Task_Due_Date": "Ημερομηνία Ολοκλήρωσης Εργασίας",
        "Task_Estimated_Hours": "Εκτιμώμενες Ώρες Εργασίας",
        "Task_Description": "Περιγραφή Εργασίας",
        "Task_Checklist": "Λίστα Ελέγχου Εργασίας",
        "Task_Checklist_Assign/remove": "Ανάθεση/Αφαίρεση Λίστας Ελέγχου Εργασίας",
        "Task_Attachments": "Επισυνάψεις Εργασίας",
        "Show_Tasks": "Εμφάνιση Εργασιών",
        "Custom_Field": "Προσαρμοσμένο Πεδίο",
        "Edit_Company": "Επεξεργασία Εταιρείας",
        "File_Extensions": "Επεκτάσεις Αρχείων",
        "Project_Milestone_Status": "Κατάσταση Σταθμού Έργου",
        "Invite_Member": "Πρόσκληση Μέλους",
        "Member_list": "Λίστα Μελών",
        "Create_Team": "Δημιουργία Ομάδας",
        "Team_List": "Λίστα Ομάδων",
        "Security_&_Permissions": "Ασφάλεια & Δικαιώματα",
        "Role_Management": "Διαχείριση Ρόλων",
        "Designation": "Τίτλος",
        "Milestone_Weekly_Range": "Εβδομαδιαίο Εύρος Σταθμού",
        "User_Timesheet": "Φύλλο Ώρων Χρήστη",
        "Project_Timesheet": "Φύλλο Ώρων Έργου",
        "Workload__Timesheet": "Φύλλο Ώρων Φορτίου Εργασίας",
        "Milestone_Report": "Αναφορά Σταθμού",
        "Project": "Έργο",
        "Task": "Εργασία",
        "Company_Settings": "Ρυθμίσεις Εταιρείας",
        "Sheet_Settings": "Ρυθμίσεις Φύλλου",
        "Team_Color": "Χρώμα Ομάδας",
        "Team_Name": "Ονόματα Ομάδων",
        "Add_Member": "Προσθήκη Μέλους",
        "Add_New_Designation": "Προσθήκη Νέου Τίτλου"
    },
    "Notification": {
        "Notification": "Ειδοποίηση",
        "notification_setting": "Ρυθμίσεις Ειδοποιήσεων",
        "browser": "Περιηγητής",
        "mobile": "Κινητό",
        "before": "Πριν",
        "chat": "Συνομιλία",
        "project": "Έργο",
        "tasks": "Εργασίες",
        "before_project_due_date": "Ημερομηνία Ολοκλήρωσης Έργου",
        "before_project_end_date": "Ημερομηνία Λήξης Έργου",
        "before_task_due_date": "Ημερομηνία Ολοκλήρωσης Εργασίας",
        "before_task_end_date": "Ημερομηνία Λήξης Εργασίας",
        "message_create": "Δημιουργία Μηνύματος",
        "project_create": "Δημιουργία Έργου",
        "project_name": "Όνομα Έργου",
        "project_status_change": "Αλλαγή Κατάστασης Έργου",
        "project_assignee": "Αναθέτης Έργου",
        "project_lead": "Υπεύθυνος Έργου",
        "project_category": "Κατηγορία Έργου",
        "project_source": "Πηγή Έργου",
        "project_type": "Τύπος Έργου",
        "project_currency": "Νόμισμα Έργου",
        "project_amount": "Ποσό Έργου",
        "project_start_date": "Ημερομηνία Έναρξης Έργου",
        "project_end_date": "Ημερομηνία Λήξης Έργου",
        "project_due_date": "Ημερομηνία Ολοκλήρωσης Έργου",
        "project_close": "Κλείσιμο Έργου",
        "project_description": "Περιγραφή Έργου",
        "project_checklist": "Λίστα Ελέγχου Έργου",
        "project_checklist_assign": "Ανάθεση Λίστας Ελέγχου Έργου",
        "project_checklist_remove": "Αφαίρεση Λίστας Ελέγχου Έργου",
        "project_attachments": "Επισυνάψεις Έργου",
        "project_milestone": "Σταθμός Έργου",
        "project_milestone_status_change": "Αλλαγή Κατάστασης Σταθμού Έργου",
        "project_sprint_create": "Δημιουργία Σπριντ Έργου",
        "project_folder_create": "Δημιουργία Φακέλου Έργου",
        "comments_im_@mentioned_in": "Σχόλια που με αναφέρουν",
        "task_notification": "Ειδοποίηση Εργασίας",
        "task_create": "Δημιουργία Εργασίας",
        "task_edit": "Επεξεργασία Εργασίας",
        "task_status": "Κατάσταση Εργασίας",
        "task_assignee": "Αναθέτης Εργασίας",
        "task_priority": "Προτεραιότητα Εργασίας",
        "task_type": "Τύπος Εργασίας",
        "task_due_date": "Ημερομηνία Ολοκλήρωσης Εργασίας",
        "task_description": "Περιγραφή Εργασίας",
        "task_checklist": "Λίστα Ελέγχου Εργασίας",
        "task_checklist_assign": "Ανάθεση Λίστας Ελέγχου Εργασίας",
        "task_checklist_remove": "Αφαίρεση Λίστας Ελέγχου Εργασίας",
        "task_attachments": "Επισυνάψεις Εργασίας",
        "comments_Im_@mentioned_in": "Σχόλια που με αναφέρουν",
        "logged_hours_notification": "Ειδοποίηση Καταγεγραμμένων Ωρών",
        "after_3_hours_today_pending_hours": "Μετά από 3 ώρες Σήμερα Ειδοποίηση Εκκρεμών Ωρών",
        "task_estimated_hours": "Εκτιμώμενες Ώρες Εργασίας"
    },
    "TimeTracker": {
        "TimeTracker": "Χρονόμετρο",
        "unlock": "Ξεκλειδώστε το Σύμπαν με το Hyphen OI Pro Tracker στην Επιφάνεια Εργασίας σας!",
        "smooth": "Παρακολουθήστε ομαλά τις ώρες που ξοδεύουν οι χρήστες σε έργα ή εργασίες με την παρακολούθηση χρόνου.",
        "click": "κάντε κλικ",
        "No_Record_Found": "Δεν βρέθηκε καταγραφή",
        "total": "Σύνολο",
        "screenshot_preview": "Προεπισκόπηση Στιγμιότυπου Οθόνης",
        "log_time_found_no_screenshot": "Η καταγραφή του χρόνου βρέθηκε, αλλά δεν καταγράφηκε στιγμιότυπο οθόνης για αυτή τη διάρκεια."
    },
    "settingslider": {
        "Time Tracking": "Παρακολούθηση Χρόνου",
        "Notifications": "Ειδοποιήσεις",
        "Company": "Εταιρεία",
        "My Settings": "Οι Ρυθμίσεις Μου",
        "Security & Permissions": "Ασφάλεια & Δικαιώματα",
        "Upgrade": "Αναβάθμιση",
        "Custom Field Manager": "Διαχειριστής Προσαρμοσμένων Πεδίων",
        "Templates": "Πρότυπα",
        "Projects": "Έργα",
        "Teams": "Ομάδες",
        "Members": "Μέλη",
        "Settings": "Ρυθμίσεις",
        "Change Password": "Αλλαγή κωδικού πρόσβασης"
    },
    "Chat": {
        "welcome_message": "Καλώς ήρθατε στο BRAND_NAME",
        "msg2": "Αυτή είναι μια ολοκαίνουργια Ομάδα. Εδώ είναι κάποια βήματα για να ξεκινήσετε. Για περισσότερα, δείτε τον οδηγό μας για αρχάριους.",
        "chats": "Συνομιλίες",
        "favorites": "Αγαπημένα",
        "CHANNELS": "ΚΑΝΑΛΙΑ"
    },
    "Comments": {
        "unread_message": "Μη αναγνωσμένα μηνύματα",
        "more": "περισσότερα",
        "less": "λιγότερα",
        "edited": "επεξεργασμένο",
        "edit": "Επεξεργασία",
        "create_task": "Δημιουργία Εργασίας",
        "add_to_checklist": "Προσθήκη στη Λίστα Ελέγχου",
        "copy_message": "Αντιγραφή Μηνύματος",
        "reply": "Απάντηση",
        "message": "Μήνυμα",
        "mark_unread": "Ανασήμανση ως Μη Αναγνωσμένο",
        "This_message_is_deleted": "Αυτό το μήνυμα έχει διαγραφεί",
        "You_deleted_this_message": "Διαγράψατε αυτό το μήνυμα",
        "no_user_found": "Δεν βρέθηκε χρήστης",
        "unlock_comment_view": "Για να ξεκλειδώσετε την προβολή σχολίων"
    },
    "PlaceHolder": {
        "enter_task_type": "Εισάγετε Τύπο Εργασίας",
        "enter_task_status": "Εισάγετε Κατάσταση Εργασίας",
        "enter_project_status": "Εισάγετε Κατάσταση Έργου",
        "Enter_Project_Name": "Εισάγετε Όνομα Έργου",
        "Enter_Key_Name": "Εισάγετε Όνομα Κλειδιού",
        "Select_Category": "Επιλέξτε Κατηγορία",
        "Select_Project_Due_Date": "Επιλέξτε Ημερομηνία Ολοκλήρωσης Έργου",
        "search": "Αναζήτηση",
        "search_here": "Αναζητήστε Εδώ",
        "Type_here": "Πληκτρολογήστε εδώ",
        "Task_name": "Όνομα Εργασίας",
        "Add_description": "Προσθήκη Περιγραφής",
        "Enter_Duplicate_Task_Name": "Εισάγετε Διπλότυπο Όνομα Εργασίας",
        "Enter_Text": "Εισάγετε Κείμενο",
        "Enter_Amount": "Εισάγετε Ποσό",
        "Select": "Επιλέξτε",
        "Enter_Refund_Amount": "Εισάγετε Ποσό Επιστροφής",
        "Enter_Milestone_Name": "Εισάγετε Όνομα Σταθμού",
        "Enter_sprint_name": "Εισάγετε Όνομα Σπριντ",
        "Enter_directory_name": "Εισάγετε Όνομα Καταλόγου",
        "Rename_Tag": "Μετονομασία Ετικέτας",
        "Enter_Team_Name": "Εισάγετε Όνομα Ομάδας",
        "Duration_only_hours": "Διάρκεια μόνο σε ώρες",
        "Enter_option": "Εισάγετε Επιλογή",
        "Enter_View_Name": "Εισάγετε Όνομα Προβολής",
        "Enter_URL": "Εισάγετε URL",
        "Enter_HTML": "Εισάγετε HTML",
        "Enter_item_name": "+ Εισάγετε όνομα αντικειμένου",
        "Add_an_item": "+ Προσθήκη Αντικειμένου",
        "Enter_Company_Name": "Εισάγετε Όνομα Εταιρείας",
        "Select_Country": "Επιλέξτε Χώρα",
        "Enter_Template": "Εισάγετε Πρότυπο",
        "Enter_Template_Name": "Εισάγετε Όνομα Προτύπου",
        "Project_key_must_be_unique": "Το κλειδί έργου πρέπει να είναι μοναδικό",
        "Enter_zip": "Εισάγετε Ταχυδρομικό Κώδικα",
        "Enter_GST_Number": "Εισάγετε Αριθμό GST",
        "Enter_Milestone_Status": "Εισάγετε Κατάσταση Σταθμού",
        "Enter_Priority_Name": "Εισάγετε Όνομα Προτεραιότητας",
        "Enter_File_Extensions_Name": "Εισάγετε Όνομα Επέκτασης Αρχείου",
        "Enter_Task_Name": "Εισάγετε Όνομα Εργασίας",
        "Select_State": "Επιλέξτε Πολιτεία",
        "No_States": "Δεν υπάρχουν Πολιτείες",
        "Select_City": "Επιλέξτε Πόλη",
        "No_Cities": "Δεν υπάρχουν Πόλεις",
        "enter_category_name": "Εισάγετε Όνομα Κατηγορίας",
        "enter_channel_name": "Εισάγετε Όνομα Καναλιού",
        "Pinned_messages": "Ακρωτηριασμένα Μηνύματα",
        "Search": "Αναζήτηση",
        "Search_by_name_or_email": "Αναζητήστε με όνομα ή email",
        "Invite_by_email": "Πρόσκληση με email",
        "Select_Designation": "Επιλέξτε Τίτλο",
        "Select_Role": "Επιλέξτε Ρόλο",
        "Enter_designation": "Εισάγετε Τίτλο",
        "Enter_Description": "Εισάγετε Περιγραφή",
        "Add_New_Role": "Προσθήκη Νέου Ρόλου",
        "Enter_role": "Εισάγετε Ρόλο",
        "Enter_Field_Label": "Εισάγετε Ετικέτα Πεδίου",
        "Enter_Placeholder": "Εισάγετε Δοκιμαστικό Κείμενο",
        "field_label": "Ετικέτα Πεδίου",
        "placeholder": "Δοκιμαστικό Κείμενο",
        "Enter_Number": "Εισάγετε Αριθμό"
    },
    "DuplicateTask": {
        "duplicate_task_name": "Διπλότυπο Όνομα Εργασίας",
        "what_do_you_copy": "Τι θέλετε να αντιγράψετε",
        "everything": "Τα πάντα",
        "no_assignee": "Χωρίς Αναθέτη",
        "no_watcher": "Χωρίς Παρατηρητή",
        "move_task": "Μετακίνηση Εργασίας",
        "mearge_task_into": "Συγχώνευση Εργασίας"
    },
    "Converttolist": {
        "are_you_sure_convert": "Είστε σίγουροι ότι θέλετε να μετατρέψετε αυτήν την εργασία σε Λίστα;",
        "important": "Σημαντικό",
        "you_will_lose": "Θα χάσετε όλα τα συνδεδεμένα σχόλια. Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",
        "convert_to_list": "Μετατροπή σε λίστα"
    },
    "Billing": {
        "billing_details": "Στοιχεία Τιμολόγησης",
        "plan_details": "Στοιχεία Σχεδίου",
        "next_msg": "Το Επόμενο Πληρωτέο Ποσό είναι",
        "due_on": "Οφείλεται στις",
        "upgrade_plan": "Αναβάθμιση Σχεδίου",
        "cancel_subscription": "Ακύρωση Συνδρομής",
        "reactivate_subscription": "Επαναφορά Συνδρομής",
        "biling_info": "Πληροφορίες Τιμολόγησης",
        "update_billing_info": "Ενημέρωση Πληροφοριών Τιμολόγησης",
        "contact_support": "Επικοινωνία με Υποστήριξη",
        "for_help_msg": "Για βοήθεια και υποστήριξη σχετικά με τις ερωτήσεις τιμολόγησης, επικοινωνήστε με την ομάδα υποστήριξής μας και θα χαρούν να σας βοηθήσουν.",
        "payment_methods": "Μέθοδοι Πληρωμής",
        "update_payment_method": "Ενημέρωση Μεθόδου Πληρωμής",
        "add_payment_method": "Προσθέστε μέθοδο πληρωμής",
        "ending_in": "λήγει στις",
        "payment_method_update": "Ενημέρωση Μεθόδου Πληρωμής Επιτυχής.",
        "waiting_msg": "Η πρόσφατη ενημέρωση της μεθόδου πληρωμής σας θα ισχύσει στον επόμενο λογαριασμό σας και θα χρησιμοποιηθεί για όλες τις μελλοντικές πληρωμές.",
        "error_updating": "Αποτυχία Ενημέρωσης Μεθόδου Πληρωμής. Παρουσιάστηκε πρόβλημα κατά την ενημέρωση της μεθόδου πληρωμής σας. Παρακαλούμε προσπαθήστε ξανά ή επικοινωνήστε με την υποστήριξη για βοήθεια.",
        "card_expires": "Η κάρτα λήγει στις",
        "billing_address": "Διεύθυνση Τιμολόγησης",
        "subscription_plan": "Σχέδιο Συνδρομής",
        "next_renew_date": "Ημερομηνία Επόμενης Ανανέωσης",
        "storage_use": "Χρήση Αποθήκευσης",
        "address": "Διεύθυνση",
        "address_line": "Γραμμή Διεύθυνσης",
        "zip_code": "Ταχυδρομικός Κώδικας",
        "zip": "Ταχυδρομικός Κώδικας",
        "Save_&_Continue": "Αποθήκευση & Συνέχεια",
        "billing_history": "Ιστορικό Τιμολόγησης",
        "Invoices": "Τιμολόγια",
        "credit_notes": "Πιστωτικά Σημειώματα",
        "download": "Λήψη",
        "id": "Αναγνωριστικό",
        "type": "Τύπος",
        "date": "Ημερομηνία",
        "description": "Περιγραφή",
        "no_of_users": "Αριθμός Χρηστών",
        "amount": "Ποσό",
        "status": "Κατάσταση",
        "pay_now": "Πληρώστε Τώρα",
        "cancelling_subscription_message": "Η ακύρωση της συνδρομής σημαίνει ότι η συνδρομή σας λήγει στις",
        "reactivate_anytime": "Μπορείτε να την επαναφέρετε οποιαδήποτε στιγμή πριν από τότε!",
        "reactivate_confirmation": "Είστε σίγουροι ότι θέλετε να επαναφέρετε τη συνδρομή σας; Επιλέγοντας 'Ναι', θα επαναφέρετε και θα συνεχίσετε το χρονοδιάγραμμα χρέωσης.",
        "amounting_to": "ανέρχεται σε",
        "insufficient_funds": "Ανεπαρκή Κεφάλαια",
        "payment_successful": "Η πληρωμή ολοκληρώθηκε με επιτυχία.",
        "payment_successful_details": "Η πληρωμή ολοκληρώθηκε! Το τιμολόγιο σας είναι πληρωμένο. Παρακαλώ επιτρέψτε 2-3 λεπτά για να ισχύσουν οι αλλαγές παντού, εξασφαλίζοντας ότι μπορείτε να απολαύσετε πλήρως τις επεκταμένες δυνατότητες και βελτιώσεις!",
        "payment_unsuccessful": "Αποτυχία Πληρωμής. Παρουσιάστηκε πρόβλημα κατά την αναβάθμιση του σχεδίου σας. Παρακαλούμε προσπαθήστε ξανά ή επικοινωνήστε με την υποστήριξη για βοήθεια.",
        "plan_upgrade_unsuccessful": "Αποτυχία Αναβάθμισης Σχεδίου. Παρουσιάστηκε πρόβλημα κατά την αναβάθμιση του σχεδίου σας. Βεβαιωθείτε ότι η κάρτα διαθέτει επαρκή υπόλοιπα.",
        "proceed_with_payment": "Θέλετε να προχωρήσετε με την πληρωμή για τον αριθμό τιμολογίου",
        "attention_needed": "Χρειαζόμαστε την προσοχή σας!",
        "avoid_service_disruption": "για να αποφύγετε διακοπή της υπηρεσίας",
        "subscription_renewal_failed": "Αποτυχία αυτόματης ανανέωσης συνδρομής λόγω",
        "update_payment_method_please": "Παρακαλώ ενημερώστε τη μέθοδο πληρωμής σας",
        "click_here_for_update_payment_method": "Κάντε κλικ εδώ για να ενημερώσετε τη μέθοδο πληρωμής",
        "credit_balance": "Υπόλοιπο Πίστωση",
        "this_balance_will_be_used_for_a_future_payment": "Αυτό το υπόλοιπο θα χρησιμοποιηθεί για μελλοντική πληρωμή.",
        "paymnet_failed_subscription_canceled": "Θα θέλαμε να σας ενημερώσουμε ότι η προηγούμενη συνδρομή σας έχει ακυρωθεί. Ο λογαριασμός σας έχει μεταβεί στη προεπιλεγμένη συνδρομή μας, η οποία έχει ορισμένες λειτουργίες απενεργοποιημένες. Για να ενεργοποιήσετε αυτές τις λειτουργίες, παρακαλούμε αναβαθμίστε το πλάνο σας.",
        "promotional_credit_balance": "Προωθητική πίστωση",
        "balance": "Υπόλοιπο",
        "created_on": "Δημιουργήθηκε στις",
        "no_promotional_found": "Δεν βρέθηκε ιστορικό προωθητικής πίστωσης"
    },
    "Tour": {
        "tour_completed": "Ο Τουρ Ολοκληρώθηκε",
        "do_you_have_any": "Έχετε απορίες; Σας ενθαρρύνουμε να εξερευνήσετε τα ολοκληρωμένα βίντεο tutorials του BRAND_NAME για να ξεκινήσετε και να αξιοποιήσετε στο έπακρο την εμπειρία σας.",
        "watch_video": "Δείτε το Βίντεο",
        "have_brief_tour_alianhub": "Κάντε μια σύντομη περιήγηση στο BRAND_NAME;",
        "have_brief_tour_alianhub_view": "Κάντε μια σύντομη περιήγηση στις προβολές του BRAND_NAME;",
        "have_brief_tour_alianhub_left_side": "Κάντε μια σύντομη περιήγηση στη λίστα των έργων;",
        "look_how_to_create": "Δείτε πώς να δημιουργήσετε έργο, να διαχειριστείτε εργασίες, να δείτε αναφορές Χρονοδιαγράμματος, να εισάγετε συνομιλία, να δείτε αναφορές και ειδοποιήσεις, και πολλά άλλα.",
        "lets_start": "Ας Ξεκινήσουμε",
        "no_thanks": "Όχι Ευχαριστώ",
        "have_brief_task": "Κάντε μια σύντομη περιήγηση στην Εργασία;",
        "have_brief_tour_project": "Κάντε μια σύντομη περιήγηση στο έργο;",
        "look_how_to_create_task": "Δείτε πώς να δημιουργήσετε εργασία, να διαχειριστείτε εργασία, να δείτε εργασία κατά κατηγορίες κατάστασης και άλλα.",
        "look_how_to_create_project": "Δείτε πώς να δημιουργήσετε έργο, να διαχειριστείτε έργο, να δείτε εργασία κατά κατηγορίες κατάστασης και άλλα.",
        "project_creation_description": "Τα έργα μπορούν να δημιουργηθούν εύκολα, να ανατεθούν και να παρακολουθηθούν, με σαφή ορατότητα των ευθυνών για τα μέλη της ομάδας. Αυτό προάγει την καλύτερη οργάνωση, οδηγώντας σε αυξημένη αποδοτικότητα και παραγωγικότητα. Κάντε κλικ εδώ για να ξεκινήσετε ένα νέο έργο.",
        "enter_project_name": "Παρακαλώ εισάγετε ένα σύντομο όνομα για το έργο σας.",
        "enter_project_key": "Παρακαλώ εισάγετε ένα σύντομο κλειδί για το έργο σας.",
        "add_project_category": "Παρακαλώ προσθέστε μια κατηγορία για το έργο σας.",
        "enter_project_duedate": "Παρακαλώ εισάγετε μια προθεσμία για το έργο σας.",
        "add_project_lead_assignee": "Παρακαλώ προσθέστε τον υπεύθυνο ανάθεσης για το έργο σας.",
        "create_project_from_template": "Αυτή η επιλογή σας επιτρέπει να δημιουργήσετε γρήγορα ένα νέο έργο χρησιμοποιώντας ένα υπάρχον πρότυπο, το οποίο έρχεται με προρυθμισμένα δεδομένα και ρυθμίσεις, επιτρέποντάς σας να αναπαράγετε εύκολα την ίδια διάταξη έργου.",
        "customize_project_section": "Αυτή η επιλογή σας επιτρέπει να προσωποποιήσετε πλήρως το έργο σας, ρυθμίζοντας διάφορα στοιχεία όπως καταστάσεις, τύπους, εφαρμογές και πολλά άλλα, προσαρμοσμένα στις ανάγκες σας.",
        "task_type_templates_list_text": "Λίστα Προτύπων Τύπων Εργασιών",
        "task_type_templates_description_text": "Αυτή η ενότητα εμφανίζει τα διαθέσιμα πρότυπα τύπων εργασιών. Επιλέξτε αυτό που ταιριάζει στις ανάγκες σας.",
        "create_new_task_type_template_text": "Δημιουργία Νέου Προτύπου Τύπου Εργασίας",
        "create_new_task_type_template_description_text": "Κάντε κλικ στο κουμπί + για να προσθέσετε ένα νέο πρότυπο τύπου εργασίας, το οποίο μπορείτε να χρησιμοποιήσετε για τις εργασίες σας.",
        "view_template_task_types_text": "Προβολή Προτύπων Τύπων Εργασιών",
        "view_template_task_types_description_text": "Εδώ μπορείτε να δείτε τους τύπους εργασιών που σχετίζονται με το επιλεγμένο πρότυπο. Μπορείτε να τροποποιήσετε ή να προσθέσετε νέους τύπους εργασιών ανάλογα με τις ανάγκες σας.",
        "add_new_task_type_text": "Προσθήκη Νέου Τύπου Εργασίας",
        "add_new_task_type_description_text": "Κάντε κλικ στο κουμπί 'Προσθήκη Τύπου Εργασίας' για να προσθέσετε νέους τύπους εργασιών στο επιλεγμένο πρότυπο.",
        "save_project_as_template_text": "Αποθήκευση Έργου ως Πρότυπο",
        "save_project_as_template_description_text": "Κάντε κλικ στο 'Αποθήκευση ως Πρότυπο' για να αποθηκεύσετε την τρέχουσα διάταξη για χρήση σε μελλοντικά έργα.",
        "initiate_new_project_text": "Έναρξη Νέου Έργου",
        "initiate_new_project_description_text": "Κάντε κλικ εδώ για να ξεκινήσετε ένα νέο έργο.",
        "add_new_task_text": "Προσθήκη Νέας Εργασίας",
        "input_task_name_text": "Εισάγετε Όνομα Εργασίας",
        "choose_task_status_text": "Επιλέξτε Κατάσταση Εργασίας",
        "assign_task_text": "Αναθέστε Εργασία",
        "set_task_deadline_text": "Ορίστε Προθεσμία Εργασίας",
        "define_task_priority_text": "Ορίστε Προτεραιότητα Εργασίας",
        "view_task_list_text": "Προβολή Λίστας Εργασιών",
        "task_information_text": "Πληροφορίες Εργασίας",
        "quick_task_menu_text": "Γρήγορο Μενού Εργασίας",
        "task_actions_text": "Ενέργειες Εργασίας",
        "subtask_toggle_text": "Εναλλαγή Υποεργασιών",
        "task_tour_complete_text": "Ο Τουρ Εργασίας Ολοκληρώθηκε",
        "create_new_task_description_text": "Δημιουργήστε μια νέα εργασία κάνοντας κλικ στο κουμπί '+ Νέα Εργασία'.",
        "input_task_name_description_text": "Εισάγετε το όνομα της εργασίας στο πεδίο εισαγωγής.",
        "choose_task_status_description_text": "Επιλέξτε τον κατάλληλο τύπο εργασίας σύμφωνα με τις ανάγκες σας.",
        "assign_task_description_text": "Επιλέξτε το άτομο στο οποίο θα ανατεθεί η εργασία.",
        "set_task_deadline_description_text": "Επιλέξτε μια προθεσμία για την εργασία.",
        "define_task_priority_description_text": "Επιλέξτε το επίπεδο προτεραιότητας για την εργασία.",
        "view_task_list_description_text": "Αυτή είναι η λίστα των εργασιών, που εμφανίζει τις λεπτομέρειες τους και ομαδοποιείται κατά κατάσταση.",
        "task_information_description_text": "Εδώ είναι οι λεπτομέρειες για την επιλεγμένη εργασία.",
        "quick_task_menu_description_text": "Κάνοντας κλικ στο εικονίδιο, ανοίγει ένα αναδυόμενο μενού με επιλογές λειτουργιών για την εργασία.",
        "task_actions_description_text": "Επιλέξτε μια ενέργεια από τη λίστα των διαθέσιμων λειτουργιών για την εργασία.",
        "subtask_toggle_description_text": "Εδώ είναι ένας διακόπτης για να εμφανίσετε τη λίστα των υποεργασιών.",
        "task_tour_complete_description_text": "Η περιήγηση ολοκληρώθηκε. Ξεκινήστε να εξερευνάτε τις πολλές δυνατότητες που έρχονται!",
        "search_and_filter_projects_text": "Αναζητήστε και Φιλτράρετε Έργα",
        "search_projects_text": "Αναζήτηση Έργων",
        "search_options_for_projects_text": "Επιλογές Αναζήτησης για Έργα",
        "search_projects_by_name_text": "Αναζήτηση Έργων κατά Όνομα",
        "advanced_project_search_text": "Προχωρημένη Αναζήτηση Έργου",
        "filter_projects_by_favorites_text": "Φιλτράρετε Έργα κατά Αγαπημένα",
        "project_settings_text": "Ρυθμίσεις Έργου",
        "project_list_text": "Λίστα Έργων",
        "end_of_project_view_tour_text": "Τέλος της Περιήγησης στην Προβολή Έργου",
        "search_and_filter_projects_description_text": "Αναζητήστε και φιλτράρετε τα έργα σύμφωνα με τα κριτήρια σας εδώ.",
        "enter_search_keywords_text": "Εισάγετε λέξεις-κλειδιά για να βρείτε συγκεκριμένα έργα.",
        "search_filter_dropdown_description_text": "Κάντε κλικ στο εικονίδιο για να ανοίξετε ένα αναδυόμενο μενού με φίλτρα αναζήτησης.",
        "toggle_search_options_description_text": "Εναλλαγή μεταξύ επιλογών αναζήτησης κατά έργο, σπριντ ή φάκελο καθώς πληκτρολογείτε.",
        "advanced_search_icon_description_text": "Κάντε κλικ στο εικονίδιο για να πραγματοποιήσετε μια προηγμένη αναζήτηση.",
        "filter_by_favorites_description_text": "Κάντε κλικ στο εικονίδιο του αστεριού για να δώσετε προτεραιότητα στα αγαπημένα σας έργα στην κορυφή της λίστας.",
        "project_settings_icon_description_text": "Κάντε κλικ στο εικονίδιο ρυθμίσεων για να εναλλάξετε μεταξύ αρχειοθετημένων ή μη αρχειοθετημένων επιλογών έργου.",
        "view_project_list_description_text": "Εδώ μπορείτε να δείτε τη λίστα των έργων σας.",
        "end_of_project_view_tour_description_text": "Η περιήγηση έχει ολοκληρωθεί.",
        "create_assign_prioritize_monitor_projects_text": "Δημιουργήστε, αναθέστε, δώστε προτεραιότητα και παρακολουθήστε έργα εύκολα. Τα μέλη της ομάδας μπορούν να δουν σαφώς τις εργασίες τους, να παραμείνουν οργανωμένα και να ενισχύσουν την αποδοτικότητα και παραγωγικότητα. Κάντε κλικ εδώ για να ξεκινήσετε ένα νέο έργο.",
        "track_users_time_sheet_reports_text": "Παρακολουθήστε αποτελεσματικά το χρόνο των χρηστών με διάφορες Αναφορές Χρονικών Φύλλων, όπως Χρονοδιαγράμματα Χρηστών, Χρονοδιαγράμματα Έργων, Χρονοδιαγράμματα Φορτίου και Χρονοδιαγράμματα Εντοπιστών. Κάντε κλικ εδώ για να εξερευνήσετε τις Αναφορές Χρονικών Φύλλων.",
        "user_time_sheet_description_text": "Το χρονοδιαγραφικό φύλλο χρήστη σας επιτρέπει να παρακολουθείτε τις ώρες που καταγράφηκαν από κάθε χρήστη σύμφωνα με το ρόλο του.",
        "project_time_sheet_description_text": "Παρακολουθήστε τις ώρες που καταγράφηκαν για κάθε έργο στο χρονοδιαγράφημα του έργου σύμφωνα με το ρόλο του χρήστη.",
        "workload_time_sheet_description_text": "Παρόμοιο με το χρονοδιαγράφημα χρήστη, το χρονοδιαγράφημα φορτίου περιλαμβάνει επίσης λεπτομέρειες σχετικά με το φορτίο του χρήστη, τις συνολικές ώρες και τις εκτιμώμενες ώρες.",
        "tracker_sheet_description_text": "Το φύλλο παρακολούθησης δείχνει τις ώρες που καταγράφηκαν μέσω του χρονομετρητή, μαζί με στιγμιότυπα οθόνης και τον συνολικό χρόνο που παρακολουθήθηκε.",
        "view_companies_switch_text": "Δείτε όλες τις εταιρείες με τις οποίες είστε συνδεδεμένοι και εναλλάξτε εύκολα μεταξύ τους επιλέγοντας μία.",
        "engage_team_real_time_text": "Συνεργαστείτε με τα μέλη της ομάδας σε πραγματικό χρόνο για γρήγορη λήψη αποφάσεων. Δημιουργήστε κανάλια και μοιραστείτε πληροφορίες μέσω συνημμένων, φωνητικών μηνυμάτων και κειμένων.",
        "real_time_notifications_text": "Μείνετε ενημερωμένοι με ειδοποιήσεις σε πραγματικό χρόνο σχετικά με τις δραστηριότητες έργου και εργασίας, όπως αναθέσεις εργασιών, αλλαγές καταστάσεων, σχόλια και προθεσμίες.",
        "address_specific_individuals_text": "Απευθυνθείτε απευθείας σε συγκεκριμένα άτομα μέσα στο σύστημα διαχείρισης έργου. Δείτε τις αναφορές που σχετίζονται με εργασίες, έργα ή συζητήσεις.",
        "access_personal_information_text": "Αποκτήστε πρόσβαση στις προσωπικές σας πληροφορίες, μαζί με ρυθμίσεις που σχετίζονται με εταιρείες, έργα, χρήστες και ασφάλεια, ανάλογα με το ρόλο του χρήστη σας.",
        "project_views_list_text": "Λίστα Προβολών Έργου",
        "add_new_project_view_text": "Προσθήκη Νέας Προβολής Έργου",
        "manage_project_views_text": "Διαχείριση Προβολών Έργου",
        "project_files_text": "Αρχεία Έργου",
        "project_audio_files_text": "Αρχεία Ήχου Έργου",
        "add_project_watcher_text": "Προσθήκη Παρατηρητή Έργου",
        "project_operation_list_text": "Λίστα Λειτουργιών Έργου",
        "advanced_task_filter_text": "Προχωρημένο Φίλτρο Εργασίας",
        "search_tasks_text": "Αναζήτηση Εργασιών",
        "search_options_menu_text": "Μενού Επιλογών Αναζήτησης",
        "search_criteria_text": "Κριτήρια Αναζήτησης",
        "project_views_list_description_text": "Μια λίστα με διαθέσιμες προβολές έργου.",
        "add_new_project_view_description_text": "Δημιουργήστε μια νέα προβολή εδώ.",
        "manage_project_views_description_text": "Εδώ μπορείτε να προσθέσετε ή να καρφιτσώσετε προβολές σε έργο. Κάντε κλικ στο 'Προσθήκη Προβολής' για να προσθέσετε ή επιλέξτε 'Καρφιτσώστε Προβολή' για να καρφιτσώσετε μια προβολή.",
        "project_files_description_text": "Αποκτήστε πρόσβαση σε όλα τα αρχεία και συνδέσμους έργου κάνοντας κλικ στο εικονίδιο.",
        "project_audio_files_description_text": "Κάντε κλικ στο εικονίδιο για να δείτε όλα τα αρχεία ήχου που σχετίζονται με το έργο.",
        "add_project_watcher_description_text": "Διαχειριστείτε τις ρυθμίσεις παρατηρητή έργου.",
        "project_operation_list_description_text": "Εκτελέστε διάφορες λειτουργίες έργου από εδώ.",
        "advanced_task_filter_description_text": "Κάντε κλικ στο εικονίδιο για να πραγματοποιήσετε μια προηγμένη αναζήτηση.",
        "search_tasks_description_text": "Εισάγετε τις σχετικές λέξεις-κλειδιά για να αναζητήσετε συγκεκριμένες εργασίες.",
        "search_options_menu_description_text": "Κάντε κλικ στο εικονίδιο για να ανοίξετε ένα αναδυόμενο μενού με διάφορες επιλογές αναζήτησης.",
        "search_criteria_description_text": "Επιλέξτε μεταξύ του ονόματος της εργασίας, του κλειδιού της ή της περιγραφής για να διευκρινίσετε την αναζήτησή σας καθώς πληκτρολογείτε.",
        "select_operation_description_text": "Επιλέξτε μια λειτουργία από τη λίστα για να εκτελέσετε την επιθυμητή ενέργεια στο έργο."
    },
    "TaskStatus": {
        "To_Do": "Προς Εκτέλεση"
    },
    "AI": {
        "generate": "Δημιουργία",
        "ai_button": "Γράψε με AI",
        "ai_title": "Ζήτησε από το AI να βρει ή να δημιουργήσει οτιδήποτε",
        "write_with_ai": "Γράψε με AI",
        "suggest_tasks": "Προτείνετε Εργασίες",
        "suggest_subtasks": "Προτείνετε Υποεργασίες",
        "ai_sidebar_placeholder": "Για τι θα ήθελες να γράψει το AI;",
        "ai_chat_placeholder": "Πες στο AI τι να κάνει στη συνέχεια",
        "ai_available_on_paid_plans_upgrade_now": "Η AI είναι διαθέσιμη μόνο σε πληρωμένα πλάνα. Αναβάθμισε το πλάνο σου και πρόσθεσε AI τώρα!",
        "please_upgrade_plan_to_use_ai": "Παρακαλώ αναβάθμισε το πλάνο σου για να χρησιμοποιήσεις το AI.",
        "read_less": "Διάβασε λιγότερα",
        "read_more": "Διάβασε περισσότερα",
        "to_unlock_ai": "Για να ξεκλειδώσεις το AI",
        "copy": "Αντιγραφή",
        "generating_results": "Δημιουργία Αποτελεσμάτων",
        "hub_ai": "HubAi",
        "regenerate": "Αναδημιουργία",
        "title": "Τίτλος",
        "error_occurred_engine_issue": "Παρουσιάστηκε σφάλμα. Ή ο κινητήρας που ζητήσατε δεν υπάρχει ή υπήρξε άλλο πρόβλημα στην επεξεργασία του αιτήματός σας",
        "ai_not_integrated": "Το AI δεν είναι ενσωματωμένο στο σύστημά σας",
        "limit_reached": "Έχετε φτάσει το όριο"
    },
    "Toast": {
        "Your_card_is_expired": "Η κάρτα σας έχει λήξει.",
        "Password_set_new_has_been_successfully": "Ο νέος κωδικός πρόσβασης έχει οριστεί με επιτυχία.",
        "task_created_successfully": "Η εργασία δημιουργήθηκε με επιτυχία",
        "please_remove_the_advanced_filter_to_view_newly_created_projects": "Αφαιρέστε το προχωρημένο φίλτρο για να δείτε τα νεοδημιουργημένα έργα.",
        "create_task_plan_limit_message": "Αναβαθμίστε το σχέδιό σας. Έχετε φτάσει το όριο για τη δημιουργία εργασιών στο sprint TASK_SPRINT.",
        "something_went_wrong": "Κάτι πήγε στραβά.",
        "file_size_is_larger_than_maxFileSize": "Το μέγεθος του αρχείου είναι μεγαλύτερο από το μέγιστο μέγεθος αρχείου.",
        "Select_image_only_and_image_file_format_should_be_FILE_FORMATS": "Επιλέξτε μόνο εικόνα και η μορφή αρχείου εικόνας πρέπει να είναι FILE_FORMATS",
        "Select_file_only_image_and_image_file_format_should_be_FILE_FORMATS": "Επιλέξτε μόνο αρχείο εικόνας και η μορφή αρχείου εικόνας πρέπει να είναι FILE_FORMATS",
        "Multiple_files_not_allowed": "Δεν επιτρέπονται πολλαπλά αρχεία.",
        "Please_select_valid_file": "Παρακαλώ επιλέξτε έγκυρο αρχείο.",
        "require_image_format_message": "Η μορφή αρχείου δεν υποστηρίζεται ή δεν έχει προστεθεί στις ρυθμίσεις της εταιρείας. Μπορείτε να προσθέσετε τη μορφή αρχείου στις Ρυθμίσεις.",
        "You_have_to_add_extension_in_setting": "Πρέπει να προσθέσετε την επέκταση στις ρυθμίσεις.",
        "Something_went_wrong_Please_try_again": "Κάτι πήγε στραβά. Παρακαλώ προσπαθήστε ξανά.",
        "Company_is_disable": "Η εταιρεία είναι απενεργοποιημένη",
        "advance_search_feature_upgrade_message": "Αυτή η δυνατότητα 'Προχωρημένη Αναζήτηση' δεν είναι διαθέσιμη στο τρέχον σχέδιό σας. Αναβαθμίστε το σχέδιό σας για να ξεκλειδώσετε την Προχωρημένη Αναζήτηση.",
        "Access_Denied": "Απαγορεύεται η πρόσβαση",
        "notification_permission": "Για να λάβετε ειδοποιήσεις, παρακαλώ επιτρέψτε την άδεια ειδοποιήσεων στις ρυθμίσεις του ιστότοπου και ανανεώστε την σελίδα.",
        "Link_is_Copied_to_clipboard": "Ο σύνδεσμος αντιγράφηκε στο πρόχειρο",
        "Task_Key_is_Copied_to_clipboard": "Το κλειδί της εργασίας αντιγράφηκε στο πρόχειρο",
        "At_least_one_field_is_required": "Απαιτείται τουλάχιστον ένα πεδίο.",
        "Task_name_updated_successfully": "Το όνομα της εργασίας ενημερώθηκε με επιτυχία",
        "Watcher_added_successfully": "Ο παρατηρητής προστέθηκε με επιτυχία",
        "Watcher_removed_successfully": "Ο παρατηρητής αφαιρέθηκε με επιτυχία",
        "Nothing_to_update": "Δεν υπάρχει τίποτα για ενημέρωση",
        "Sprint created successfully": "Το Sprint δημιουργήθηκε με επιτυχία",
        "Sprint restored successfully": "Το Sprint αποκαταστάθηκε με επιτυχία",
        "Sprint closed successfully": "Το Sprint έκλεισε με επιτυχία",
        "Sprint archived successfully": "Το Sprint αρχειοθετήθηκε με επιτυχία",
        "Sprint deleted successfully": "Το Sprint διαγράφηκε με επιτυχία",
        "Upgrade_your_plan_you_have_reached_the_limit_for_creating_sprints": "Αναβαθμίστε το σχέδιό σας. Έχετε φτάσει το όριο για τη δημιουργία sprints.",
        "Folder created successfully": "Ο φάκελος δημιουργήθηκε με επιτυχία",
        "Folder updated successfully": "Ο φάκελος ενημερώθηκε με επιτυχία",
        "Folde restored successfully": "Ο φάκελος αποκαταστάθηκε με επιτυχία",
        "Folder closed successfully": "Ο φάκελος έκλεισε με επιτυχία",
        "Folder archived successfully": "Ο φάκελος αρχειοθετήθηκε με επιτυχία",
        "Folder deleted successfully": "Ο φάκελος διαγράφηκε με επιτυχία",
        "Status_changed_successfully": "Η κατάσταση άλλαξε με επιτυχία",
        "Due_date_updated_successfully": "Η προθεσμία ενημερώθηκε με επιτυχία",
        "Due_date_not_updated": "Η προθεσμία δεν ενημερώθηκε",
        "Assignee changed_uccessfully": "Ο ανατεθείς άλλαξε με επιτυχία",
        "Assignee added successfully": "Ο ανατεθείς προστέθηκε με επιτυχία",
        "Assignee removed successfully": "Ο ανατεθείς αφαιρέθηκε με επιτυχία",
        "Assignee not updated": "Ο ανατεθείς δεν ενημερώθηκε",
        "Task_updated_successfully": "Η εργασία ενημερώθηκε με επιτυχία",
        "Task_restored_successfully": "Η εργασία αποκαταστάθηκε με επιτυχία",
        "Task_archived_successfully": "Η εργασία αρχειοθετήθηκε με επιτυχία",
        "Task_deleted_successfully": "Η εργασία διαγράφηκε με επιτυχία",
        "Tag_Deleted_successfully": "Η ετικέτα διαγράφηκε με επιτυχία",
        "Log_time_added_successfully": "Ο χρόνος καταγράφηκε με επιτυχία.",
        "Filter_saved_successfully": "Το φίλτρο αποθηκεύτηκε με επιτυχία.",
        "Filter_update_successfully": "Το φίλτρο ενημερώθηκε με επιτυχία.",
        "Filter_deleted_successfully": "Το φίλτρο διαγράφηκε με επιτυχία.",
        "Checklist_creted_succesfully.": "Η λίστα ελέγχου δημιουργήθηκε με επιτυχία.",
        "Please_select_checklist": "Παρακαλώ επιλέξτε λίστα ελέγχου.",
        "already_exists": "Η EXIST_VALUE υπάρχει ήδη",
        "Converted_sucessfully": "Μετατράπηκε με επιτυχία",
        "create_task_limit_in_sprint_upgrade_task_message": "Αναβαθμίστε το σχέδιό σας. Έχετε φτάσει το όριο για τη δημιουργία εργασιών στο sprint SELECTED_SPRINT_DATA.",
        "Please_Select_Task_Type": "Παρακαλώ επιλέξτε τύπο εργασίας",
        "Please_Select_Task": "Παρακαλώ επιλέξτε εργασία",
        "Task_moved_sucessfully": "Η εργασία μετακινήθηκε με επιτυχία",
        "Task_not_moved": "Η εργασία δεν μετακινήθηκε",
        "Task_duplicate_sucessfully": "Η εργασία αντιγράφηκε με επιτυχία",
        "Task_not_duplicated": "Η εργασία δεν αντιγράφηκε",
        "Convert_in_to_task_sucessfully": "Μετατράπηκε σε εργασία με επιτυχία",
        "Company_name_already_exists": "Το όνομα της εταιρείας υπάρχει ήδη",
        "Company_has_been_created_Successfully": "Η εταιρεία δημιουργήθηκε με επιτυχία.",
        "Custom_field_updated_successfully": "Το προσαρμοσμένο πεδίο ενημερώθηκε με επιτυχία",
        "No_assignee_found": "Δεν βρέθηκε ανατεθείς",
        "No_due_date_found": "Δεν βρέθηκε προθεσμία",
        "No_self_assignee_found": "Δεν βρέθηκε αυτοανατεθείς",
        "Estimated_time_updated_successfully": "Ο εκτιμώμενος χρόνος ενημερώθηκε με επιτυχία",
        "Description_updated_successfully": "Η περιγραφή ενημερώθηκε με επιτυχία",
        "Description_not_updated": "Η περιγραφή δεν ενημερώθηκε",
        "Copied": "Αντιγράφηκε!",
        "User_removed_successfully": "Ο χρήστης αφαιρέθηκε με επιτυχία",
        "Invitation_cancelled_successfully": "Η πρόσκληση ακυρώθηκε με επιτυχία",
        "User_role_changed_successfully": "Ο ρόλος του χρήστη άλλαξε με επιτυχία",
        "User_designation_changed_successfully": "Η επαγγελματική θέση του χρήστη άλλαξε με επιτυχία.",
        "Please_upgrade_your_plan_to_use_Time_Tracker": "Παρακαλώ αναβαθμίστε το σχέδιό σας για να χρησιμοποιήσετε τον Χρόνο Παρακολούθησης.",
        "Request_remove_successfully": "Η αίτηση αφαιρέθηκε με επιτυχία",
        "Upgrade_Your_Plan": "Αναβαθμίστε το σχέδιό σας",
        "Updated_successfully": "Ενημερώθηκε με επιτυχία",
        "Deleted_successfully": "Διαγράφηκε με επιτυχία",
        "View_Pinned": "Προβολή καρφιτσωμένων",
        "View_Unpinned": "Προβολή χωρίς καρφίτσωμα",
        "View_Already_Added": "Προβολή που έχει ήδη προστεθεί",
        "Company_details_saved_successfully": "Οι λεπτομέρειες της εταιρείας αποθηκεύτηκαν με επιτυχία.",
        "Currency_added_successfully": "Νόμισμα προστέθηκε με επιτυχία",
        "Currency_removed_successfully": "Νόμισμα αφαιρέθηκε με επιτυχία",
        "File_extension_remove_successfully": "Η επέκταση αρχείου FILE_EXTENSION καταργήθηκε με επιτυχία",
        "File_extension_update_successfully": "Η επέκταση αρχείου ενημερώθηκε με επιτυχία.",
        "Status_updated_successfully": "Η κατάσταση ενημερώθηκε με επιτυχία",
        "Project_milestone_status_Deleted_successfully": "Η κατάσταση του ορόσημου έργου διαγράφηκε με επιτυχία.",
        "Milestone_weekly_range_updated_successfully": "Η εβδομαδιαία κλίμακα ορόσημου ενημερώθηκε με επιτυχία.",
        "Image_dimensions_should_not_exceed_ImageDimensions_pixels": "Οι διαστάσεις της εικόνας δεν πρέπει να υπερβαίνουν τα ImageDimensions pixels.",
        "error_in_uploading_image_please_try_it_again": "Σφάλμα κατά την ανέβασμα της εικόνας. Παρακαλώ προσπαθήστε ξανά",
        "Task_priority_updated_successfully": "Η προτεραιότητα της εργασίας ενημερώθηκε με επιτυχία.",
        "Task_priority_Remove_successfully": "Η προτεραιότητα της εργασίας αφαιρέθηκε με επιτυχία.",
        "Priority_updated_successfully": "Η προτεραιότητα ενημερώθηκε με επιτυχία",
        "Priority_not_updated": "Η προτεραιότητα δεν ενημερώθηκε",
        "error_in_deleting_priority_please_try_it_again": "Σφάλμα κατά τη διαγραφή προτεραιότητας, παρακαλώ προσπαθήστε ξανά",
        "Field_Enable_Successfully": "Το πεδίο ενεργοποιήθηκε με επιτυχία",
        "Field_Disable_Successfully": "Το πεδίο απενεργοποιήθηκε με επιτυχία",
        "Field_Added_Successfully": "Το πεδίο προστέθηκε με επιτυχία",
        "Field_Updated_Successfully": "Το πεδίο ενημερώθηκε με επιτυχία",
        "Added_to_favourite": "Προστέθηκε στα αγαπημένα",
        "Removed_from_favourite": "Αφαιρέθηκε από τα αγαπημένα",
        "Tag_Created_successfully": "Η ετικέτα δημιουργήθηκε με επιτυχία",
        "Queue list added successfully": "Η λίστα αναμονής προστέθηκε με επιτυχία",
        "Queue list removed successfully": "Η λίστα αναμονής αφαιρέθηκε με επιτυχία",
        "Queue list not updated": "Η λίστα αναμονής δεν ενημερώθηκε",
        "Attachments_uploaded_successfully": "Τα επισυναπτόμενα αρχεία ανέβηκαν με επιτυχία",
        "Attachment_removed_successfully": "Το επισυναπτόμενο αρχείο αφαιρέθηκε με επιτυχία",
        "Attachment_not_removed": "Το επισυναπτόμενο αρχείο δεν αφαιρέθηκε",
        "Please_try_again": "Παρακαλώ προσπαθήστε ξανά",
        "Task_name_copied": "Το όνομα της εργασίας αντιγράφηκε",
        "Status_already_exists": "Η κατάσταση υπάρχει ήδη",
        "Status_added_sucessfully": "Η κατάσταση προστέθηκε με επιτυχία",
        "Task_Type_already_exists": "Ο τύπος εργασίας υπάρχει ήδη",
        "Task_Type_added_sucessfully": "Ο τύπος εργασίας προστέθηκε με επιτυχία",
        "Image_size_must_be_less_than_ImageDimensions_pixels": "Το μέγεθος της εικόνας πρέπει να είναι μικρότερο από ImageDimensions pixels.",
        "Data_deleted_successfully": "Τα δεδομένα διαγράφηκαν με επιτυχία.",
        "Category_created_successfully": "Η κατηγορία δημιουργήθηκε με επιτυχία",
        "Please_select_an_image_file": "Παρακαλώ επιλέξτε ένα αρχείο εικόνας",
        "Channel_created_successfully": "Το κανάλι δημιουργήθηκε με επιτυχία",
        "Folder_not_found": "Ο φάκελος δεν βρέθηκε",
        "Template_&_Project_data_has_been_added_successfully": "Τα δεδομένα του προτύπου και του έργου προστέθηκαν με επιτυχία.",
        "Project_data_has_been_added_successfully": "Τα δεδομένα του έργου προστέθηκαν με επιτυχία{filterMessage}",
        "Error_in_creating_project": "Σφάλμα κατά τη δημιουργία έργου",
        "Milestone_deleted_successfully": "Το ορόσημο διαγράφηκε με επιτυχία",
        "Error_in_deleting_milestone": "Σφάλμα κατά τη διαγραφή του ορόσημου",
        "Milestone_added_successfully": "Το ορόσημο προστέθηκε με επιτυχία",
        "Error_in_adding_milestone": "Σφάλμα κατά την προσθήκη ορόσημου",
        "Milestone_update_successfully": "Το ορόσημο ενημερώθηκε με επιτυχία",
        "Error_in_updating_milestone": "Σφάλμα κατά την ενημέρωση του ορόσημου",
        "Milestone_status_update_successfully": "Η κατάσταση του ορόσημου ενημερώθηκε με επιτυχία",
        "Error_in_updating_milestone_status": "Σφάλμα κατά την ενημέρωση της κατάστασης του ορόσημου",
        "Milestone_refund_amount_update_successfully": "Η ενημέρωση του ποσού επιστροφής του ορόσημου έγινε με επιτυχία",
        "Error_in_updating_milestone_refund_amount": "Σφάλμα κατά την ενημέρωση του ποσού επιστροφής ορόσημου",
        "The_project_not_found": "Το έργο δεν βρέθηκε.",
        "The_project_is_archived": "Το έργο είναι αρχειοθετημένο.",
        "Start_date_of_project_should_be_smaller_than_current_date": "Η ημερομηνία έναρξης του έργου πρέπει να είναι μικρότερη από την τρέχουσα ημερομηνία",
        "All_the_range_is_included_in_milestone": "Όλο το εύρος περιλαμβάνεται στο ορόσημο",
        "Please_enter_start_date_of_project": "Παρακαλώ εισάγετε την ημερομηνία έναρξης του έργου",
        "Project_name_updated_successfully": "Το όνομα του έργου ενημερώθηκε με επιτυχία",
        "Project restored successfully": "Το έργο αποκαταστάθηκε με επιτυχία",
        "Project closed successfully": "Το έργο έκλεισε με επιτυχία",
        "Project archived successfully": "Το έργο αρχειοθετήθηκε με επιτυχία",
        "Project deleted successfully": "Το έργο διαγράφηκε με επιτυχία",
        "Enter_valid_project_source": "Εισάγετε έγκυρη πηγή έργου",
        "Please_select_sub_task": "Παρακαλώ επιλέξτε υποεργασία.",
        "Status_not_updated": "Η κατάσταση δεν ενημερώθηκε",
        "Start_date_updated_successfully": "Η ημερομηνία έναρξης ενημερώθηκε με επιτυχία",
        "Start_date_not_updated": "Η ημερομηνία έναρξης δεν ενημερώθηκε",
        "Task_converted_sucessfully": "Η εργασία μετατράπηκε με επιτυχία",
        "Task_merged_sucessfully": "Η εργασία συγχωνεύτηκε με επιτυχία",
        "Can_not_create_template_name_Custom": "Δεν μπορείτε να δημιουργήσετε το όνομα προτύπου Custom",
        "Template_name_updated_successfully": "Το όνομα προτύπου ενημερώθηκε με επιτυχία.",
        "Template_has_been_created_Successfully": "Το πρότυπο δημιουργήθηκε με επιτυχία.",
        "Template_deleted_successfull": "Το πρότυπο διαγράφηκε με επιτυχία.",
        "Template_has_been_deleted_successfully": "Το πρότυπο διαγράφηκε με επιτυχία.",
        "Storage_exceeded_Upgrade_your_plan": "Το αποθηκευτικό χώρο ξεπεράστηκε. Αναβαθμίστε το πρόγραμμα σας",
        "max_filesize_messages": "Το μέγιστο μέγεθος αρχείου είναι FILE_SIZE MB.",
        "Password_reset_email_has_been_sent_successfully": "Το email επαναφοράς κωδικού στάλθηκε με επιτυχία",
        "Invalid_username_or_password": "Άκυρο όνομα χρήστη ή κωδικός.",
        "Email_Not_Verified": "Το email δεν έχει επαληθευτεί.",
        "Verification_mail_has_been_send_successfully": "Το email επαλήθευσης στάλθηκε με επιτυχία",
        "Invalid_url": "Άκυρη διεύθυνση URL",
        "User_already_registered": "Ο χρήστης είναι ήδη καταχωρημένος.",
        "User_has_been_registered_successfully": "Ο χρήστης καταχωρήθηκε με επιτυχία.",
        "The_email_address_is_already_in_use": "Η διεύθυνση email χρησιμοποιείται ήδη",
        "User_has_been_registered_successfully_Please_verify_your_email_to_continue": "Ο χρήστης καταχωρήθηκε με επιτυχία, παρακαλώ επαληθεύστε το email σας για να συνεχίσετε.",
        "Password_reset_has_been_successfully": "Η επαναφορά του κωδικού ολοκληρώθηκε με επιτυχία",
        "Your_email_has_been_verify_successfully": "Το email σας επαληθεύτηκε με επιτυχία",
        "Invitation_accepted_successfully": "Η πρόσκληση έγινε αποδεκτή με επιτυχία",
        "Only_product_owner_can_create_a_company": "Μόνο ο κάτοχος του προϊόντος μπορεί να δημιουργήσει μια εταιρεία",
        "Company_name_must_be_unique": "Το όνομα της εταιρείας πρέπει να είναι μοναδικό.",
        "Subscription_cancel_succesfully_Please_allow_2_to_3_minutes_for_the_changes_to_take_effect_everywhere": "Η συνδρομή ακυρώθηκε με επιτυχία. Παρακαλώ επιτρέψτε 2 έως 3 λεπτά για να ισχύσουν οι αλλαγές παντού.",
        "Subscription_reactivate_succesfully_Please_allow_2_to_3_minutes_for_the_changes_to_take_effect_everywhere": "Η συνδρομή ενεργοποιήθηκε ξανά με επιτυχία. Παρακαλώ επιτρέψτε 2 έως 3 λεπτά για να ισχύσουν οι αλλαγές παντού.",
        "View_name_is_required": "Το όνομα θέασης είναι απαραίτητο",
        "name_should_be_at_least_3_characters_long": "Το όνομα πρέπει να είναι τουλάχιστον 3 χαρακτήρες",
        "View_name_already_exists": "Το όνομα θέασης υπάρχει ήδη",
        "View_added_successfully": "Η θέαση προστέθηκε με επιτυχία",
        "View_Deleted_Successfully": "Η θέαση διαγράφηκε με επιτυχία",
        "Link_copied_to_clipboard_successfully": "Ο σύνδεσμος αντιγράφηκε στο πρόχειρο με επιτυχία",
        "Project_avatar_updated_successfully": "Η εικόνα προφίλ του έργου ενημερώθηκε με επιτυχία",
        "Message pinned successfully": "Το μήνυμα καρφιτσώθηκε με επιτυχία",
        "Message unpinned successfully": "Το μήνυμα αποκαρφιτσώθηκε με επιτυχία",
        "Message_copied": "Το μήνυμα αντιγράφηκε",
        "Item_cannot_be_empty": "Το στοιχείο δεν μπορεί να είναι κενό",
        "Maximum_MAX_CHAR_characters_are_allowed": "Επιτρέπονται μέγιστοι MAX_CHAR χαρακτήρες",
        "Item_added_to_checklist": "Το στοιχείο προστέθηκε στη λίστα ελέγχου",
        "Maximum_10_files_can_be_uploaded_at_once": "Μέγιστο 10 αρχεία μπορούν να ανέβουν ταυτόχρονα",
        "file_type_is_not_supported": "Ο τύπος αρχείου δεν υποστηρίζεται!",
        "ERROR_in_file_upload": "ΣΦΑΛΜΑ κατά την αποστολή αρχείου",
        "file_size_is_larger_than_FILE_SIZE_mb": "Το μέγεθος του αρχείου είναι μεγαλύτερο από FILE_SIZE MB!",
        "Mark_as_favorite_successfully": "Σημειώθηκε ως αγαπημένο με επιτυχία",
        "Start_and_Due_date_updated_successfully": "Η ημερομηνία έναρξης και λήξης ενημερώθηκαν με επιτυχία",
        "Start_and_Due_date_not_updated": "Η ημερομηνία έναρξης και λήξης δεν ενημερώθηκαν",
        "Attchments_deleted_successfully": "Τα συνημμένα διαγράφηκαν με επιτυχία",
        "Designation_is_required": "Η θέση είναι απαραίτητη",
        "Designation_already_exists": "Η θέση υπάρχει ήδη",
        "Designation_added_successfully": "Η θέση προστέθηκε με επιτυχία",
        "Designation_updated_successfully": "Η θέση ενημερώθηκε με επιτυχία",
        "Role_is_required": "Ο ρόλος είναι απαραίτητος",
        "Role_already_exists": "Ο ρόλος υπάρχει ήδη",
        "Role_added_successfully": "Ο ρόλος προστέθηκε με επιτυχία",
        "Role_updated_successfully": "Ο ρόλος ενημερώθηκε με επιτυχία",
        "Please_provide_an_email_id": "Παρακαλώ παρέχετε ένα email",
        "Please_provide_a_designation": "Παρακαλώ παρέχετε μια θέση",
        "Please_provide_a_role": "Παρακαλώ παρέχετε ένα ρόλο",
        "Designation_deleted_successfully": "Η θέση διαγράφηκε με επιτυχία",
        "The_role_is_already_in_use_so_it_cant_be_deleted": "Ο ρόλος χρησιμοποιείται ήδη, επομένως δεν μπορεί να διαγραφεί.",
        "Role_deleted_successfully": "Ο ρόλος διαγράφηκε με επιτυχία",
        "Language_not_updated": "Η γλώσσα δεν ενημερώθηκε!",
        "Profile_updated_successfully": "Το προφίλ ενημερώθηκε με επιτυχία.",
        "Notification_Settings_Update_successfully": "Η ενημέρωση των ρυθμίσεων ειδοποιήσεων ολοκληρώθηκε με επιτυχία",
        "Permission_updated_successfully": "Η άδεια ενημερώθηκε με επιτυχία",
        "Per_User_Generate_Limit_value_is_not_valid": "Η τιμή για το όριο δημιουργίας ανά χρήστη δεν είναι έγκυρη",
        "Team_name_is_required": "Το όνομα της ομάδας είναι απαραίτητο",
        "Minimum_3_character_required": "Απαιτούνται τουλάχιστον 3 χαρακτήρες",
        "Team_name_already_exist": "Το όνομα της ομάδας υπάρχει ήδη",
        "Template_has_been_added_successfully": "Το πρότυπο προστέθηκε με επιτυχία.",
        "Billing_details_has_been_updated_successfully": "Τα στοιχεία τιμολόγησης ενημερώθηκαν με επιτυχία",
        "Billing_details_not_updated": "Τα στοιχεία τιμολόγησης δεν ενημερώθηκαν",
        "Invalid_Card_Details_Please_check_and_try_again": "Μη έγκυρες λεπτομέρειες κάρτας. Παρακαλώ ελέγξτε και προσπαθήστε ξανά.",
        "Expired_Card_Please_check_and_try_again": "Η κάρτα έχει λήξει. Παρακαλώ ελέγξτε και προσπαθήστε ξανά.",
        "Invalid_card_verification_code_(CVC)_Please_check_and_try_again": "Μη έγκυρος κωδικός επαλήθευσης κάρτας (CVC). Παρακαλώ ελέγξτε και προσπαθήστε ξανά.",
        "You_have_cancel_your_current_subscription_at_term_end_please_reactivate_subscription_and_try_again": "Έχετε ακυρώσει τη συνδρομή σας στο τέλος της περιόδου, παρακαλώ επαναφέρετε τη συνδρομή και προσπαθήστε ξανά.",
        "Plan_not_purchased_Please_try_again": "Το πρόγραμμα δεν αγοράστηκε. Παρακαλώ προσπαθήστε ξανά.",
        "Please_fill_out_billing_details_first": "Παρακαλώ συμπληρώστε πρώτα τα στοιχεία τιμολόγησης.",
        "Please_check_your_credential": "Παρακαλώ ελέγξτε τα διαπιστευτήριά σας.",
        "File_type_not_supported": "Ο τύπος αρχείου δεν υποστηρίζεται",
        "Are_you_sure_to_delete_this_file": "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το αρχείο;",
        "Select_Project_Type": "Επιλέξτε τύπο έργου",
        "Tracker_user_added_successfully": "Ο χρήστης του Tracker προστέθηκε με επιτυχία",
        "Tracker_user_removed_successfully": "Ο χρήστης του Tracker αφαιρέθηκε με επιτυχία",
        "queue_list_not_updated": "Η λίστα αναμονής δεν ενημερώθηκε.",
        "upgrade_plan_folder_limit_reached": "Αναβαθμίστε το πρόγραμμα σας. Έχετε φτάσει το όριο δημιουργίας φακέλων",
        "View_updated_successfully": "Η θέαση ενημερώθηκε με επιτυχία",
        "The_designation_is_already_in_use_so_it_cant_be_deleted": "Η θέση είναι ήδη σε χρήση, επομένως δεν μπορεί να διαγραφεί",
        "Sprint_already_exists": "Ο σπριντ υπάρχει ήδη",
        "Folder_already_exists": "Ο φάκελος υπάρχει ήδη",
        "Sprint updated successfully": "Ο σπριντ ενημερώθηκε με επιτυχία",
        "Project_milestone_status_updated_successfully": "Η κατάσταση του ορόσημου έργου ενημερώθηκε με επιτυχία.",
        "Invalid_email": "Το email σας δεν είναι έγκυρο. Ελέγξτε και δοκιμάστε ξανά",
        "Invalid_password": "Ο κωδικός πρόσβασής σας δεν είναι έγκυρος. Ελέγξτε και δοκιμάστε ξανά",
        "Too_many_request": "Πάρα πολλά αιτήματα. Δοκιμάστε ξανά αργότερα",
        "Password_reset_link": "Το email λήξης κωδικού πρόσβασης στάλθηκε με επιτυχία! Ελέγξτε τα εισερχόμενά σας για να προχωρήσετε στην επαναφορά του κωδικού πρόσβασής σας.",
        "Project_milestone_status_added_successfully": "Η κατάσταση ορόσημο του έργου προστέθηκε με επιτυχία.",
        "Please_select_start_end_date": "Παρακαλώ επιλέξτε και την ημερομηνία έναρξης και λήξης",
        "Invitation_canceled": "Η πρόσκληση ακυρώθηκε: Δεν μπορείτε πλέον να χρησιμοποιήσετε αυτόν τον σύνδεσμο",
        "Ai_limit_reached": "Έχετε φτάσει το ημερήσιο όριο σας.",
        "You_have_reached_the_maximum_limit_of_guest_users": "Αναβαθμίστε το πλάνο σας. Έχετε φτάσει το μέγιστο όριο επισκεπτών χρηστών.",
        "Upgrade_for_import": "Αναβαθμίστε το πλάνο σας για να αποκτήσετε πρόσβαση στη λειτουργία εισαγωγής.",
        "Upgrade_for_export": "Αναβαθμίστε το πλάνο σας για να αποκτήσετε πρόσβαση στη λειτουργία εξαγωγής.",
        "import_task_success": "Οι εργασίες σας έχουν εισαχθεί με επιτυχία.",
        "export_task_success": "Οι εργασίες εξήχθησαν με επιτυχία.",
        "export_task_error": "Δεν υπάρχουν εργασίες προς εξαγωγή.",
        "invalid_file_error": "Μη έγκυρος τύπος αρχείου. Παρακαλώ ανεβάστε ένα αρχείο .csv.",
        "free_company_limit_reached": "Έχετε φτάσει το μέγιστο όριο για τη δημιουργία δωρεάν εταιρειών.",
        "Import_users_successfully": "Οι χρήστες εισήχθησαν με επιτυχία",
        "date_range": "Παρακαλώ επιλέξτε ένα εύρος ημερομηνιών πριν συνεχίσετε.",
        "Task_total_estimate_update_succesfull": "Επιτυχής ενημέρωση της συνολικής εκτίμησης της εργασίας"
    },
    "SecurityAndPermission": {
        "project": "Έργο",
        "project_list": "Λίστα Έργων",
        "project_create": "Δημιουργία Έργου",
        "project_name_edit": "Επεξεργασία Ονόματος Έργου",
        "project_sprint_create": "Δημιουργία Sprint Έργου",
        "project_folder_create": "Δημιουργία Φακέλου Έργου",
        "project_folder_name_edit": "Επεξεργασία Ονόματος Φακέλου Έργου",
        "project_sprint_name_edit": "Επεξεργασία Ονόματος Sprint Έργου",
        "project_details": "Λεπτομέρειες Έργου",
        "project_status_change": "Αλλαγή Κατάστασης Έργου",
        "project_assignee": "Ανατεθειμένο Πρόσωπο Έργου",
        "project_category": "Κατηγορία Έργου",
        "project_source": "Πηγή Έργου",
        "project_type": "Τύπος Έργου",
        "project_currency": "Νόμισμα Έργου",
        "project_amount": "Ποσό Έργου",
        "project_start_date": "Ημερομηνία Έναρξης Έργου",
        "project_end_date": "Ημερομηνία Λήξης Έργου",
        "project_due_date": "Ημερομηνία Λήξης",
        "project_close": "Κλείσιμο Έργου",
        "project_description": "Περιγραφή Έργου",
        "project_checklist": "Λίστα Ελέγχου Έργου",
        "project_checklist_assign_remove": "Ανάθεση/Αφαίρεση Λίστας Ελέγχου Έργου",
        "project_attachments": "Συνημμένα Έργου",
        "project_milestone": "Ορόσημο Έργου",
        "task": "Εργασία",
        "task_list": "Λίστα Εργασιών",
        "task_create": "Δημιουργία Εργασίας",
        "sub_task_create": "Δημιουργία Υπο-Εργασίας",
        "task_name_edit": "Επεξεργασία Ονόματος Εργασίας",
        "task_status": "Κατάσταση Εργασίας",
        "task_assignee": "Ανατεθειμένο Πρόσωπο Εργασίας",
        "task_priority": "Προτεραιότητα Εργασίας",
        "task_due_date": "Ημερομηνία Λήξης Εργασίας",
        "task_estimated_hours": "Εκτιμώμενες Ώρες Εργασίας",
        "task_description": "Περιγραφή Εργασίας",
        "task_checklist": "Λίστα Ελέγχου Εργασίας",
        "task_checklist_assign_remove": "Ανάθεση/Αφαίρεση Λίστας Ελέγχου Εργασίας",
        "task_attachments": "Συνημμένα Εργασίας",
        "show_tasks": "Εμφάνιση Εργασιών",
        "task_custom_field": "Προσαρμοσμένο Πεδίο",
        "settings": "Ρυθμίσεις Εταιρείας",
        "settings_edit_company": "Επεξεργασία Εταιρείας",
        "settings_task_priority": "Προτεραιότητα Εργασίας",
        "settings_file_extensions": "Επεκτάσεις Αρχείων",
        "settings_project_milestone_status": "Κατάσταση Ορόσημου Έργου",
        "settings_invite_member": "Πρόσκληση Μέλους",
        "settings_member_list": "Λίστα Μελών",
        "settings_create_team": "Δημιουργία Ομάδας",
        "settings_team_list": "Λίστα Ομάδων",
        "settings_project_list": "Λίστα Έργων",
        "settings_security_permissions": "Ασφάλεια και Άδειες",
        "settings_role_management": "Διαχείριση Ρόλων",
        "settings_designation": "Θέση",
        "milestone_weekly_range": "Εβδομαδιαία Εύρος Ορόσημου",
        "settings_custom_field": "Προσαρμοσμένο Πεδίο",
        "sheet_settings": "Ρυθμίσεις Φύλλου",
        "user_timesheet": "Φύλλο Ώρας Χρήστη",
        "project_timesheet": "Φύλλο Ώρας Έργου",
        "workload_timesheet": "Φύλλο Ώρας Φορτίου Εργασίας",
        "milestone_report": "Αναφορά Ορόσημου",
        "artificial_intelligence": "Τεχνητή Νοημοσύνη",
        "per_user_generate_limit": "Όριο Δημιουργίας Ανά Χρήστη",
        "project_custom_field": "Προσαρμοσμένο Πεδίο Έργου",
        "public_projects": "Δημόσια Λίστα Έργων",
        "tracker_timesheet": "Φύλλο Ώρας Παρακολούθησης",
        "view_list": "Προβολή λίστας",
        "chat": "Plauderei",
        "project_delete": "Διαγραφή έργου",
        "folder_archive": "Αρχειοθέτηση φακέλου",
        "folder_delete": "Διαγραφή φακέλου",
        "folder_restore": "Επαναφορά φακέλου",
        "sprint_type_change": "Αλλαγή τύπου σπριντ",
        "sprint_restore": "Επαναφορά σπριντ",
        "sprint_delete": "Διαγραφή σπριντ",
        "sprint_archive": "Αρχειοθέτηση σπριντ",
        "chat_channel": "Δημιουργία καναλιού συνομιλίας",
        "chat_category": "Δημιουργία κατηγορίας συνομιλίας",
        "one_to_one_chat": "Συνομιλία ένας προς έναν",
        "task_tag": "Ετικέτα εργασίας",
        "task_start_date": "Ημερομηνία έναρξης εργασίας",
        "task_activity_log": "Ημερολόγιο δραστηριοτήτων εργασίας",
        "task_convert_to_list": "Μετατροπή εργασίας σε λίστα",
        "task_convert_to_subtask": "Μετατροπή εργασίας σε υποεργασία",
        "task_duplicate": "Αντιγραφή εργασίας",
        "task_merge": "Συγχώνευση εργασίας",
        "task_move": "Μετακίνηση εργασίας",
        "task_archive": "Αρχειοθέτηση εργασίας",
        "task_delete": "Διαγραφή εργασίας",
        "task_comment": "Σχόλιο εργασίας",
        "task_details": "Λεπτομέρειες εργασίας",
        "queue_list": "Λίστα αναμονής",
        "advance_search": "Προηγμένη αναζήτηση",
        "list_view_column": "Στήλη προβολής λίστας",
        "task_type": "Τύπος εργασίας",
        "import_tasks": "Εισαγωγή εργασιών",
        "export_tasks": "Εξαγωγή εργασιών",
        "convert_to_task": "Μετατροπή σε εργασία"
    },
    "general": {
        "Continue": "Συνέχεια",
        "New_Status": "Νέα Κατάσταση",
        "Old_Status": "Παλιά Κατάσταση",
        "Old_Task_Type": "Παλαιός Τύπος Εργασίας",
        "New_Task_Type": "Νέος Τύπος Εργασίας",
        "New_Task_Assignee": "Νέο Πρόσωπο Ανατεθειμένο στην Εργασία",
        "Old_Task_Assignee": "Παλαιό Πρόσωπο Ανατεθειμένο στην Εργασία",
        "New_Task_Watchers": "Νέοι Παρατηρητές Εργασίας",
        "Old_Task_Watchers": "Παλιοί Παρατηρητές Εργασίας",
        "Select_Status": "Επιλέξτε Κατάσταση",
        "Select_Task_Type": "Επιλέξτε Τύπο Εργασίας",
        "No_Assignee": "Χωρίς Ανατεθειμένο Πρόσωπο",
        "No_Watchers": "Χωρίς Παρατηρητές",
        "Different_Statuses": "Διαφορετικές Καταστάσεις",
        "Please_Select_Status": "Παρακαλώ Επιλέξτε Κατάσταση",
        "Tomorrow": "Αύριο",
        "Yesterday": "Χθες",
        "Project": "Έργο",
        "Team": "Ομάδα",
        "User": "Χρήστης",
        "Copy_Assignees": "Αντιγραφή Ανατεθειμένων Προσώπων",
        "Copy_Watchers": "Αντιγραφή Παρατηρητών",
        "apply": "Εφαρμογή",
        "current_month": "Τρέχων Μήνας",
        "current_week": "Τρέχουσα Εβδομάδα",
        "keyboard": "Πληκτρολόγιο",
        "mouse": "Ποντίκι",
        "Create": "Δημιουργία",
        "scroll_to_bottom": "Κύληση στο Κάτω Μέρος",
        "unassigned": "Μη Ανατεθειμένο",
        "entries": "καταχωρήσεις",
        "showing": "Εμφάνιση",
        "page_not_found": "Ουπς, η σελίδα δεν βρέθηκε",
        "page_not_found_description": "Λυπούμαστε πολύ για την αναστάτωση. Φαίνεται ότι προσπαθείτε να αποκτήσετε πρόσβαση σε μια σελίδα που έχει διαγραφεί ή δεν υπήρξε ποτέ.",
        "note": "Σημείωση",
        "settings_change_no_effect": "Η αλλαγή των παρακάτω ρυθμίσεων δεν θα επηρεάσει τις τρέχουσες τιμές πεδίων αν δεν είναι κενές",
        "advanced": "Προηγμένα",
        "general": "Γενικά",
        "limits": "Όρια",
        "message_deleted": "Μήνυμα διαγράφηκε",
        "company_individual": "Όνομα εταιρείας/ατόμου",
        "enter_company_individual": "Εισαγάγετε το όνομα της εταιρείας/ατόμου"
    },
    "monthName": {
        "jan": "Ιαν",
        "feb": "Φεβ",
        "mar": "Μαρ",
        "apr": "Απρ",
        "may": "Μάι",
        "jun": "Ιούν",
        "jul": "Ιούλ",
        "aug": "Αυγ",
        "sep": "Σεπ",
        "oct": "Οκτ",
        "nov": "Νοε",
        "dec": "Δεκ"
    },
    "timeLog": {
        "start_time_field_required": "Το πεδίο ώρας έναρξης είναι υποχρεωτικό",
        "end_time_field_required": "Το πεδίο ώρας λήξης είναι υποχρεωτικό",
        "select_valid_time_duration": "Παρακαλώ επιλέξτε έγκυρη διάρκεια χρόνου"
    },
    "weekName": {
        "sun": "Κυρ",
        "mon": "Δευ",
        "tue": "Τρι",
        "wed": "Τετ",
        "thu": "Πεμ",
        "fri": "Παρ",
        "sat": "Σαβ",
        "fridays": "Παρασκευές",
        "mondays": "Δευτέρες",
        "saturdays": "Σάββατα",
        "sundays": "Κυριακές",
        "thursdays": "Πέμπτες",
        "tuesdays": "Τρίτες",
        "wednesdays": "Τετάρτες"
    },
    "tooltipText": {
        "enable_app_manage_priority": "Ενεργοποιώντας αυτήν την εφαρμογή, θα μπορείτε να διαχειριστείτε την <b>Προτεραιότητα</b> στις <b>Εργασίες</b> για αυτό το <b>έργο</b>",
        "enable_app_manage_multiple_assignee": "Ενεργοποιώντας αυτήν την εφαρμογή, θα μπορείτε να διαχειριστείτε <b>Πολλαπλούς Ανατεθειμένους</b> στις <b>Εργασίες</b> για αυτό το <b>έργο</b>",
        "enable_app_manage_time_estimates": "Ενεργοποιώντας αυτήν την εφαρμογή, θα μπορείτε να διαχειριστείτε τις <b>Εκτιμήσεις Χρόνου</b> στις <b>Εργασίες</b> για αυτό το <b>έργο</b>",
        "enable_app_manage_tags": "Ενεργοποιώντας αυτήν την εφαρμογή, θα μπορείτε να διαχειριστείτε τις <b>Ετικέτες</b> στις <b>Εργασίες</b> για αυτό το <b>έργο</b>",
        "enable_app_use_milestones": "Ενεργοποιώντας αυτήν την εφαρμογή, θα μπορείτε να χρησιμοποιήσετε τα <b>Ορόσημα</b> για αυτό το <b>έργο</b>",
        "enable_app_use_ai_operations": "Ενεργοποιώντας αυτήν την εφαρμογή, θα μπορείτε να χρησιμοποιήσετε τις <b>Λειτουργίες Τεχνητής Νοημοσύνης</b> για αυτό το <b>έργο</b>",
        "enable_app_manage_time_log": "Ενεργοποιώντας αυτήν την εφαρμογή, θα μπορείτε να διαχειριστείτε το <b>Ημερολόγιο Χρόνου</b> στις <b>Εργασίες</b> για αυτό το <b>έργο</b>",
        "enable_app_manage_custom_fields": "Ενεργοποιώντας αυτήν την εφαρμογή, θα μπορείτε να διαχειριστείτε τα <b>Προσαρμοσμένα Πεδία</b> για αυτό το <b>έργο</b>"
    },
    "Company": {
        "fill_company_details": "Συμπληρώστε τα στοιχεία της εταιρείας σας",
        "set_up_company": "Ρυθμίστε την Εταιρεία σας",
        "creating_company": "Δημιουργία Εταιρείας",
        "company_created": "Η εταιρεία σας δημιουργήθηκε. Έχουμε ρυθμίσει τα πρώτα βήματα. Παρακαλούμε περιμένετε λίγο.",
        "good_to_go": "Έτοιμο για χρήση",
        "select_default_country": "Επιλέξτε την Προεπιλεγμένη Χώρα",
        "freelimitreachedstart": "Έχετε ήδη δημιουργήσει μια δωρεάν εταιρεία. Για να δημιουργήσετε μια νέα εταιρεία, πρέπει πρώτα να αναβαθμίσετε σε ένα επί πληρωμή πρόγραμμα",
        "freelimitreachedend": "Μόλις αναβαθμιστείτε, θα είστε έτοιμοι να προσθέσετε μια άλλη δωρεάν εταιρεία."
    },
    "Subscription": {
        "subscription_cancelled": "Έχετε ακυρώσει τη συνδρομή σας στο τέλος της τρέχουσας περιόδου συνδρομής",
        "discard_changes": "Ένας χρήστης στη συνδρομή σας θα απορρίψει αυτές τις αλλαγές και η τρέχουσα συνδρομή σας θα συνεχιστεί από τον επόμενο κύκλο χρέωσης.",
        "confirm_terminate_schedule": "Είστε βέβαιοι ότι θέλετε να τερματίσετε τον προγραμματισμένο τερματισμό συνδρομής;",
        "confirm_add_user": "Είστε βέβαιοι ότι θέλετε να προσθέσετε χρήστη στη συνδρομή σας;",
        "confirm_remove_user": "Είστε βέβαιοι ότι θέλετε να αφαιρέσετε το χρήστη από τη συνδρομή σας;",
        "next_invoice_amount": "Το επόμενο τιμολόγιο σας θα είναι για",
        "credits_applied": "Πιστώσεις Εφαρμόστηκαν",
        "current_billing_for_upgrade": "Τρέχουσα Χρέωση για Αναβάθμιση",
        "plan_upgrade_success": "Συγχαρητήρια! Η αναβάθμιση του σχεδίου σας έχει προγραμματιστεί με επιτυχία και οι βελτιώσεις θα τεθούν σε εφαρμογή μετά το τέλος της τρέχουσας περιόδου. Ετοιμαστείτε να απολαύσετε τα αναβαθμισμένα χαρακτηριστικά και οφέλη στην επόμενη φάση της συνδρομής σας.",
        "subscription_upgrade_from": "Η συνδρομή σας θα αναβαθμιστεί από",
        "total_payable_amount": "Συνολικό Ποσό Πληρωτέο",
        "update_subscription": "Ενημέρωση Συνδρομής",
        "updated_subscription_price": "Ενημερωμένη Τιμή Συνδρομής",
        "upgrade_subscription": "Αναβάθμιση Συνδρομής",
        "confirm_subscription_change": "Είστε βέβαιοι ότι θέλετε να αλλάξετε τη συνδρομή σας από",
        "monthly": "Μήνας",
        "yearly": "Έτος",
        "remove_scheduled_cancellation_confirmation": "Επιλέγοντας 'Ναι' θα αφαιρέσετε την προγραμματισμένη ακύρωση και ο κύκλος χρέωσης θα συνεχιστεί.",
        "scheduled_cancellation_notice": "Έχετε προγραμματισμένη ακύρωση της τρέχουσας συνδρομής σας στις",
        "credit_entitlement_congratulations": "Συγχαρητήρια! Έχετε δικαίωμα σε πίστωση αξίας",
        "credit_note_application": "για τη τρέχουσα συνδρομή σας. Αυτή η πιστωτική σημείωση θα εφαρμοστεί με ευκολία για να ενισχύσει τη συνδρομή σας και θα αφαιρεθεί αυτόματα από τα επερχόμενα τιμολόγιά σας, εξασφαλίζοντας συνεχιζόμενη αξία και εξοικονόμηση για τη συνδρομητική σας πορεία.",
        "invoice_period_coverage": "Το τιμολόγιο καλύπτει την περίοδο από"
    },
    "Card": {
        "pay_with": "Πληρώστε με",
        "add_new_card": "Προσθήκη Νέας Κάρτας",
        "name_on_card": "Όνομα στην Κάρτα",
        "card_number": "Αριθμός Κάρτας",
        "expiry": "Ημερομηνία Λήξης",
        "cvc": "CVC"
    },
    "alertBox": {
        "updateBillingAddress": "Πρέπει να ενημερώσετε την πρώτη διεύθυνση χρέωσης",
        "valid_csv_title": "Μη έγκυρο αρχείο",
        "valid_csv_text": "Ανεβάστε ένα έγκυρο αρχείο .csv για να συνεχίσετε.",
        "ok": "OK",
        "cancel": "Ακύρωση",
        "go_back_title": "Επιστροφή πίσω;",
        "go_back_text": "Είστε σίγουροι ότι θέλετε να επιστρέψετε στο προηγούμενο βήμα;",
        "close_modal_title": "Κλείσιμο παραθύρου;",
        "close_modal_text": "Είστε σίγουροι ότι θέλετε να κλείσετε το παράθυρο; Όλες οι πληροφορίες που εισαγάγατε σε αυτό το βήμα θα χαθούν.",
        "no": "Όχι",
        "yes": "Ναι",
        "confirm": "Επιβεβαίωση",
        "improper_header_selection_title": "Μη έγκυρη επιλογή",
        "improper_header_selection_text": "Η επιλεγμένη γραμμή περιέχει μη κειμενικές τιμές. Επιλέξτε μια άλλη γραμμή.",
        "missing_fields_title": "Λείπουν υποχρεωτικά πεδία",
        "missing_fields_text": "Πρέπει να αντιστοιχίσετε και να επιβεβαιώσετε όλα τα υποχρεωτικά πεδία πριν προχωρήσετε.",
        "warning_title": "Προειδοποίηση",
        "warning_text": "Αν συνεχίσετε, οι κενές τιμές στα πεδία 'Προτεραιότητα Εργασίας' και 'Κατάσταση' θα οριστούν αυτόματα σε 'Μεσαία' και 'Σε εκκρεμότητα'.",
        "incomplete_mapping_title": "Μη ολοκληρωμένη αντιστοίχιση",
        "incomplete_mapping_text": "Παρακαλώ αντιστοιχίστε τουλάχιστον όλες τις μοναδικές τιμές σε μια τιμή στο Hyphen OI Pro πριν προχωρήσετε.",
        "invalid_tasks_error": "Δεν βρέθηκαν έγκυρες εργασίες. Βεβαιωθείτε ότι τα απαιτούμενα πεδία δεν είναι κενά."
    },
    "importTaskButton": {
        "import_title": "Εισαγωγή εργασιών",
        "import_button": "Εισαγωγή εργασιών από CSV",
        "back_button": "Πίσω",
        "next_button": "Επόμενο",
        "export_button": "Εξαγωγή ως CSV",
        "import_processing": "Οι εργασίες σας εισάγονται."
    },
    "importCsvAndSetHeader": {
        "download": "Λήψη",
        "demo_csv": "Δείγμα CSV",
        "down_demo_text": "Συγκρίνετε αυτό το αρχείο με το αρχείο που θέλετε να εισαγάγετε για να διασφαλίσετε ότι η μορφή είναι σωστή.",
        "upload_button": "Ανεβάστε το αρχείο CSV σας εδώ",
        "upload_instructions": "Μπορείτε να ανεβάσετε οποιοδήποτε αρχείο .csv με οποιοδήποτε σύνολο στηλών, όπου κάθε γραμμή αντιπροσωπεύει μία εγγραφή. Στο επόμενο βήμα, θα μπορείτε να αντιστοιχίσετε τις στήλες στα αντίστοιχα δεδομένα. Πριν από την τελική εισαγωγή, θα μπορείτε να διαγράψετε ή να διορθώσετε τυχόν εσφαλμένα δεδομένα.",
        "header_row_question": "Η επιλεγμένη γραμμή περιέχει τις επικεφαλίδες των στηλών;",
        "select_another_button": "Επιλέξτε άλλη γραμμή",
        "confirm_row_btt": "Επιβεβαίωση"
    },
    "headerMapping": {
        "title": "Αντιστοιχίστε τις επικεφαλίδες των στηλών",
        "mapping_instructions": "Αντιστοιχίστε τις επικεφαλίδες των στηλών σας με τα πεδία του Hyphen OI Pro",
        "pending_count": "Εναπομείναντα πεδία:",
        "confirmed_count": "Επιβεβαιωμένα πεδία:",
        "ignored_count": "Αγνοημένα πεδία:",
        "custom_count": "Προσαρμοσμένα πεδία:",
        "confirmed_text": "Επιβεβαιωμένο",
        "ignored_text": "Αγνοημένο",
        "edit_button": "Επεξεργασία",
        "no_match_title": "Χωρίς αντιστοίχιση",
        "no_match": "Δεν βρέθηκε αντιστοίχιση",
        "no_match_description": "Αυτό το πεδίο δεν αντιστοιχεί σε καμία επικεφαλίδα του Hyphen OI Pro. Μπορείτε να το αγνοήσετε ή να το προσθέσετε ως προσαρμοσμένο πεδίο.",
        "custom_field_button": "Προσθήκη ως προσαρμοσμένο πεδίο",
        "ignore_field_button": "Αγνόηση αυτού του πεδίου",
        "matched_to_field": "Αντιστοιχίστηκε στο πεδίο:",
        "duplication_warning": "Αυτό το πεδίο είναι διπλό και δεν μπορεί να επιβεβαιωθεί. Επιλέξτε άλλο πεδίο.",
        "confirm_map_button": "Επιβεβαίωση αντιστοίχισης"
    },
    "reviewMaping": {
        "title": "Ελέγξτε τα δεδομένα που έχουν αντιστοιχιστεί στα πεδία. (Μπορείτε επίσης να επεξεργαστείτε τις τιμές εδώ.)",
        "warning": "Ένα ή περισσότερα υποχρεωτικά πεδία λείπουν ή περιέχουν μη έγκυρες τιμές. Ελέγξτε τα, διαφορετικά αυτές οι γραμμές δεν θα εισαχθούν."
    },
    "valueMapping": {
        "user_mapping_title": "Αντιστοίχιση χρηστών",
        "user_mapping_instruction": "Αντιστοιχίστε τους χρήστες με τους αντίστοιχους χρήστες στο Hyphen OI Pro για να εξασφαλίσετε τη σωστή ανάθεση υπευθύνων, ηγετών και εργασιών. Εάν δεν γίνει αντιστοίχιση, αυτά τα δεδομένα δεν θα εισαχθούν.",
        "user_dropdown_text": "Επιλέξτε χρήστη",
        "status_mapping_title": "Αντιστοίχιση κατάστασης",
        "status_mapping_instruction": "Για να διασφαλίσετε μια συνεπή ροή εργασίας, αντιστοιχίστε τις καταστάσεις σας στις αντίστοιχες στο Hyphen OI Pro. Αυτό θα βοηθήσει στην αποφυγή μελλοντικών σφαλμάτων.",
        "status_dropdown_text": "Επιλέξτε κατάσταση",
        "priority_mapping_title": "Αντιστοίχιση προτεραιότητας",
        "priority_mapping_instruction": "Για να διασφαλίσετε μια συνεπή ροή εργασίας, αντιστοιχίστε τις προτεραιότητές σας στις αντίστοιχες στο Hyphen OI Pro. Αυτό θα βοηθήσει στην αποφυγή μελλοντικών σφαλμάτων.",
        "priority_dropdown_text": "Επιλέξτε προτεραιότητα",
        "custom_field_mapping_title": "Αντιστοίχιση προσαρμοσμένων πεδίων",
        "custom_field_mapping_instruction": "Για να διασφαλίσετε τη συμβατότητα, αντιστοιχίστε τον τύπο του προσαρμοσμένου πεδίου σας με έναν υπάρχοντα τύπο πεδίου στο Hyphen OI Pro. Αυτό θα βοηθήσει στην αποφυγή μελλοντικών σφαλμάτων.",
        "custom_delimiters_quest": "ℹ️ Τα προσαρμοσμένα πεδία σας περιέχουν οριοθέτες;"
    },
    "importMappingKeywords": {
        "task_id_description": "Το αναγνωριστικό της συγκεκριμένης εργασίας.",
        "task_name_description": "Το όνομα της εργασίας, συνήθως μια σύντομη περίληψη.",
        "task_description_description": "Λεπτομερείς πληροφορίες σχετικά με την εργασία.",
        "task_assignee_description": "Η διεύθυνση email του ατόμου που έχει ανατεθεί στην εργασία.",
        "task_parentId_description": "Το αναγνωριστικό της γονικής εργασίας με την οποία σχετίζεται αυτή η εργασία.",
        "task_leaderId_description": "Το αναγνωριστικό χρήστη του ατόμου που ηγείται αυτής της εργασίας.",
        "task_priority_description": "Το επίπεδο σημασίας που αποδίδεται στην εργασία.",
        "task_status_description": "Η τρέχουσα κατάσταση ή πρόοδος της εργασίας.",
        "task_start_date_description": "Η ημερομηνία έναρξης της εργασίας.",
        "task_due_date_description": "Η ημερομηνία ολοκλήρωσης της εργασίας."
    },
    "Affiliate": {
        "refer_earn": "Σύστησε και κέρδισε",
        "unlimited": "Απεριόριστο",
        "invite_start_earning_cash_rewards": "Προσκαλέστε τους φίλους σας και αρχίστε να κερδίζετε χρηματικές ανταμοιβές.",
        "your_referral_code": "Ο κωδικός παραπομπής σας",
        "invite_spend_message": "Για κάθε δαπάνη του φίλου σας, θα λαμβάνετε το {percentage}% του ποσού ως ανταμοιβή.",
        "inviteText": "Προσκαλέστε φίλους κοινοποιώντας αυτόν τον σύνδεσμο",
        "copy": "Αντιγραφή",
        "refferal_code_label": "Κωδικός παραπομπής",
        "refferal_code_placeholder": "Εισαγάγετε τον κωδικό παραπομπής",
        "invalid_refferal_model_title": "Ο κωδικός παραπομπής σας δεν είναι έγκυρος",
        "invalid_refferal_model_confirm_text": "Ναι, δημιουργήστε το!",
        "invalid_refferal_model_text": "Είστε βέβαιοι ότι θέλετε να δημιουργήσετε μια εταιρεία;",
        "refferal_code_error": "Ο κωδικός παραπομπής δεν είναι έγκυρος"
    },
    "dashboardCard": {
        "tasks_by_assignee_bar_chart_description": "Εμφάνιση γραφήματος ράβδων των συνολικών εργασιών σας ανά ανάθεση",
        "tasks_by_assignee_bar_chart_title": "Εργασίες ανά Ανάθεση",
        "task_list_description": "Δημιουργήστε μια προβολή λίστας χρησιμοποιώντας εργασίες από οποιαδήποτε τοποθεσία",
        "tasks_list_title": "Λίστα Εργασιών",
        "tasks_by_assignee_stack_bar_chart_description": "Εμφάνιση διαβαθμισμένου γραφήματος ράβδων των συνολικών εργασιών σας ανά ανάθεση",
        "tasks_by_assignee_stack_bar_chart_title": "Εργασίες ανά Ανάθεση",
        "workload_by_status_stack_bar_chart_description": "Εμφάνιση ανάλυσης των καταστάσεών σας σε διάφορες τοποθεσίες",
        "workload_by_status_stack_bar_chart_title": "Φόρτος Εργασίας ανά Κατάσταση",
        "tasks_by_assignee_pie_chart_description": "Εμφάνιση κυκλικού γραφήματος των συνολικών εργασιών σας ανά ανάθεση",
        "tasks_by_assignee_pie_chart_title": "Εργασίες ανά Ανάθεση",
        "workload_by_status_pie_chart_description": "Εμφάνιση κυκλικού γραφήματος της χρήσης των καταστάσεών σας σε διάφορες τοποθεσίες",
        "workload_by_status_pie_chart_title": "Φόρτος Εργασίας ανά Κατάσταση",
        "workload_by_status_bar_chart_description": "Εμφάνιση γραφήματος ράβδων της χρήσης των καταστάσεών σας σε διάφορες τοποθεσίες",
        "workload_by_status_bar_chart_title": "Φόρτος Εργασίας ανά Κατάσταση",
        "queue_list_title": "Λίστα Αναμονής",
        "queue_list_description": "Δείτε μια λίστα με τις εργασίες σας μαζί με τις καταστάσεις τους.",
        "card_name": "Όνομα Κάρτας",
        "location": "σχέδιο",
        "group_by": "Ομαδοποίηση κατά",
        "show_assignees": "Εμφάνιση Αναθέσεων",
        "include_subtasks": "Συμπερίληψη Υποεργασιών",
        "display_labels_as_percent": "Εμφάνιση ετικετών ως ποσοστό",
        "show_legend": "Εμφάνιση Υπομνήματος",
        "show_Data_Labels": "Εμφάνιση Ετικετών Δεδομένων",
        "select": "Επιλογή",
        "add_card": "Προσθήκη Κάρτας",
        "back": "Πίσω",
        "error_assignees": "Το πεδίο 'Εμφάνιση Αναθέσεων' είναι υποχρεωτικό",
        "error_location": "Το πεδίο 'Τοποθεσία' είναι υποχρεωτικό",
        "empty_layout_container": "Ο πίνακας ελέγχου σας είναι άδειος. Κάντε κλικ στο 'Προσθήκη κάρτας' για να ξεκινήσετε.",
        "status": "κατάσταση",
        "edit_card": "επεξεργασία κάρτας",
        "calendar_card_title": "Ημερολόγιο",
        "calendar_card_description": "Αυτή είναι η προβολή ημερολογίου για εργασίες",
        "measure": "μέτρο",
        "calculation": "υπολογισμός",
        "total_urgent_tasks": "Συνολικές επείγουσες εργασίες",
        "total_urgent_tasks_description": "Εμφάνιση του συνολικού αριθμού των επειγόντων εργασιών ανά τοποθεσία",
        "time_tracker": "Παρακολούθηση χρόνου",
        "time_estimate": "Εκτίμηση χρόνου",
        "range": "Εύρος",
        "max": "Μέγιστο",
        "min": "Ελάχιστο",
        "median": "Διάμεσος",
        "average": "Μέσος όρος",
        "sum": "Άθροισμα",
        "workload_estination_title": "Αναφορά χρόνου",
        "workload_estination_description": "Δείτε εργασίες με καταγεγραμμένο και εκτιμώμενο χρόνο.",
        "workload_only_estination_title": "Εκτιμώμενος χρόνος",
        "workload_only_estination_description": "Δείτε τον εκτιμώμενο χρόνο.",
        "time_only_estination_title": "Καταγεγραμμένος χρόνος",
        "time_only_estination_description": "Δείτε τον καταγεγραμμένο χρόνο.",
        "today": "Σήμερα",
        "yesterday": "Χθες",
        "this_week": "Αυτή την εβδομάδα",
        "last_week": "Την προηγούμενη εβδομάδα",
        "this_month": "Αυτόν τον μήνα",
        "last_month": "Τον προηγούμενο μήνα",
        "this_year": "Αυτό το έτος",
        "last_30_days": "Τελευταίες 30 ημέρες",
        "task": "Καταμέτρηση εργασιών",
        "task_label": "Ετικέτα εργασίας",
        "both": "Εμφάνιση και των δύο",
        "manual_time": "Εμφάνιση μόνο του μη αυτόματου χρόνου",
        "track_time": "Εμφάνιση μόνο του παρακολουθούμενου χρόνου",
        "logtype": "Χρονικά αρχεία",
        "timerange": "Χρονικό διάστημα",
        "priority": "Προτεραιότητα",
        "due_date": "Ημερομηνία λήξης",
        "none": "Κανένα",
        "total_time_track_description": "Εμφάνιση συνολικού χρόνου παρακολούθησης",
        "total_time_track_tasks": "Συνολικός χρόνος παρακολούθησης",
        "total_tasks_count_description": "Εμφάνιση συνολικού αριθμού εργασιών",
        "total_tasks_count": "Συνολικός αριθμός εργασιών",
        "assignees": "Ανατεθέντες",
        "feature": "Λειτουργία",
        "workload": "Φορτίο εργασίας",
        "time_tracking": "Παρακολούθηση χρόνου",
        "task_card": "Εργασίες",
        "Today": "Σήμερα",
        "Yesterday": "Χθες",
        "Tomorrow": "Αύριο",
        "This_week": "Αυτή την εβδομάδα",
        "Next_week": "Επόμενη εβδομάδα",
        "Next_seven_days": "Επόμενες επτά ημέρες",
        "Last_seven_days": "Τελευταίες επτά ημέρες",
        "Last_month": "Προηγούμενος μήνας",
        "This_month": "Αυτός ο μήνας",
        "Next_month": "Επόμενος μήνας",
        "Date_range": "Εύρος ημερομηνιών",
        "me_mode": "εγώ",
        "data": "Δεδομένα",
        "display": "Εμφάνιση",
        "fields": "Πεδία"
    },
    "designationMapping": {
        "title": "Χαρτογράφηση Θέσεων Εργασίας",
        "description": "Παρακαλώ αντιστοιχίστε τις θέσεις εργασίας στο CSV σας με τις υπάρχουσες θέσεις εργασίας στο Hyphen OI Pro."
    },
    "roleMapping": {
        "title": "Χαρτογράφηση Ρόλων",
        "description": "Παρακαλώ αντιστοιχίστε τους ρόλους στο CSV σας με τους υπάρχοντες ρόλους στο Hyphen OI Pro."
    },
    "importUserKeywords": {
        "user_email_description": "Email ID του χρήστη",
        "user_role_description": "Ο ρόλος ή ο τίτλος εργασίας που έχει ανατεθεί στον χρήστη μέσα στον οργανισμό.",
        "user_designation_description": "Ο επίσημος τίτλος θέσης εργασίας του υπαλλήλου στην εταιρεία."
    },
    "userSelection": {
        "title": "Επιλογή Χρηστών",
        "user_limit_error": "Έχετε φτάσει στο μέγιστο όριο χρηστών. Παρακαλώ αναβαθμίστε το πλάνο σας για να εισάγετε περισσότερους χρήστες.",
        "description": "Επιλέξτε όλους τους χρήστες που θέλετε να εισαγάγετε.",
        "duplicate_email_error": "Αυτό το Email ID υπάρχει ήδη στο Hyphen OI Pro. Δεν μπορείτε να το εισαγάγετε.",
        "invalid_email": "Αυτό το Email ID δεν είναι έγκυρο. Παρακαλώ χρησιμοποιήστε ένα έγκυρο Email ID.",
        "invalid_fields": "Έχετε ένα ή περισσότερα μη έγκυρα πεδία. Παρακαλώ ελέγξτε τα επισημασμένα πεδία.",
        "user_limit_100": "Μπορείτε να εισαγάγετε έως και 100 χρήστες ταυτόχρονα."
    },
    "importUserButton": {
        "import_user_processing": "Οι χρήστες σας εισάγονται"
    },
    "timeForecastingReport": {
        "project_name": "Όνομα έργου",
        "project_status": "Κατάσταση έργου",
        "start_date": "Ημερομηνία έναρξης",
        "due_date": "Καταληκτική ημερομηνία",
        "last_logged_date": "Τελευταία καταγεγραμμένη ημερομηνία",
        "budget": "Προϋπολογισμός",
        "actual": "Πραγματικό",
        "forecast": "Πρόβλεψη",
        "estimated_hours": "Εκτιμώμενες ώρες",
        "logged_hours": "Καταγεγραμμένες ώρες",
        "remaining_hours": "Υπολειπόμενες ώρες",
        "overdue_hours": "Καθυστερημένες ώρες",
        "estimated_time_to_complete": "Εκτιμώμενος χρόνος ολοκλήρωσης",
        "estimated_complition_date": "Εκτιμώμενη ημερομηνία ολοκλήρωσης",
        "show_legends": "Εμφάνιση υπομνημάτων",
        "show_data_labels": "Εμφάνιση ετικετών δεδομένων",
        "report_type": "Τύπος αναφοράς"
    }
}